import React, { Component } from "react";
import { connect } from "react-redux";
import { TweenMax, Back, Sine } from "gsap";
import { getHighScores, setMute, gameMusic, playSndFx, toggleMute, audioChosen, deletePlaybackToken } from "../../actions/actionCreators.js";
import Hud from './../hud/Hud';
import AudioNotice from './../AudioNotice';
import _ from 'lodash';
import * as alltheimages from "../Images.js";

const mapDispatchToProps = dispatch => ({
	getHighScores: () => dispatch(getHighScores()),
	toggleMute: () => dispatch(toggleMute()),
	audioChosen: () => dispatch(audioChosen()),
	deletePlaybackToken: () => dispatch(deletePlaybackToken()),
	setMute: (mute) => {
		dispatch(setMute(mute));
	},
	gameMusic: (music) => {
		dispatch(gameMusic(music))
	},
	playSndFx: (sfx) => {
		dispatch(playSndFx(sfx))
	}
});

const mapStateToProps = state => {
	const g = state.game;
	return {
		mute: g.mute,
		token : state.game.token,
		audioSet: g.audioSet,
		showDebug: false
	};
};

class StartScreenView extends Component {
	constructor(props) {
		super(props);
		this.errorCount = 0;
		this.assetLoaderErrorLog = [];
		this.cache = {};
		this.out = false;
		this.state = {
			successCount: 0,
			soundQueue: [],
			assetsLoaded: false,
			imageArray: [],
			assetLoaderErrorLog: [],
			errorCount: 0,
			startScreenReady: false
		};
	}

	componentDidMount() {
		// console.log(this.props);
		// console.log(this.props);
		this.checkMute();
		this.props.getHighScores();
		this.prepForIntroAnimation();
		if (this.props.audioSet) TweenMax.delayedCall(1, () => this.animateLogo());
		this.getImagesToLoad();
	}

	checkMute () {
		const isMuteSet = this.props.mute;
		if (isMuteSet === undefined) {
			// console.log('setting mute');
			this.props.setMute(true);
		}
	}

	prepForIntroAnimation() {
		// hide background lightning and bg as a whole
		TweenMax.set('.animatedBg', {autoAlpha: 0});
		TweenMax.set([this.refs.glint1, this.refs.glint2, this.refs.glint3], {autoAlpha: 0}); // button glints
		TweenMax.set([this.refs.bottom], { autoAlpha: 0, y: 50, transformOrigin: "50% 50%" });
		let bgLightning = [this.refs.lightning1, this.refs.lightning2, this.refs.lightning3, this.refs.lightning4];

		_.forEach(bgLightning, lightning => {
			TweenMax.set(lightning, {
				autoAlpha: 0
			});
		});
	}

	getRandomInt (min, max) {
		return Math.floor(Math.random() * (max - min + 1)) + min;
	}

	getRandomArbitrary(min, max) {
		return Math.random() * (max - min) + min;
	}

	doLightning () {
		if (this.out) return;

		let bgLightning = [this.refs.lightning4, this.refs.lightning1, this.refs.lightning2, this.refs.lightning3];
		_.forEach(bgLightning, (lightning, index) => {
			if (index <= 1) TweenMax.set(lightning, { x: 0 - this.getRandomInt(0,900) })
			else TweenMax.set(lightning, { x: this.getRandomInt(0,900) })
			// TweenMax.to(lightning, this.getRandomArbitrary(0.2, 0.4), {delay: this.getRandomInt(1,5), autoAlpha: 1, yoyo: true, repeat: 1})
			TweenMax.delayedCall(this.getRandomInt(1,5), () => {
				this.showLightning(lightning);
				this.props.playSndFx('startThunder');
			})
		})
		if (!this.out) TweenMax.delayedCall(5, () => this.doLightning());
	}

	showLightning (lightning) {
		TweenMax.set(this.refs.sky, {fill: '#ffffff'});
		TweenMax.to(lightning, this.getRandomArbitrary(0.2, 0.4), {autoAlpha: 1, yoyo: true, repeat: 1});
		TweenMax.to(this.refs.sky, 0.3, {fill: '#000000', ease: Sine.easeOut, delay: 0.1});
	}

	animateLogo () {
		TweenMax.delayedCall(1, () => this.doLightning());

		TweenMax.to('.animatedBg', 1, {autoAlpha: 1, delay: 0.3})
		let flames = this.refs.flames.childNodes;
		_.forEach(flames, (flame) => {
			TweenMax.set(flame, {
				scaleX: 0,
				scaleY: 0,
				opacity: 0,
				y: 150,
				transformOrigin: "50% 50%"
			});
		})
		TweenMax.set(this.refs.container, {visibility: "visible" })
		_.forEach(flames, (flame, index) => {
			TweenMax.to(flame , 0.25, {
				opacity: 1,
				delay: index * 0.05,
				scaleX: 1,
				scaleY: 1,
				y: 0,
				ease: Back.easeOut
			});
			TweenMax.to(flame , this.getRandomArbitrary(1, 3), {
				rotation: this.getRandomArbitrary(-4,4),
				delay: this.getRandomArbitrary(1, 1.5),
				ease: Sine.easeOut,
				transformOrigin: "50% 100%",
				yoyo: true,
				repeat: -1,
				repeatDelay: 0.25
			});
		})
		TweenMax.set([this.refs.triangle], { scaleX: 0, scaleY: 0, opacity: 0, y:-50, transformOrigin: "50% 50%" });
		TweenMax.set([this.refs.click], { y:200, opacity: 0, transformOrigin: "50% 50%" });
		TweenMax.set([this.refs.rage], { scaleX: 2, scaleY: 2, opacity: 0, y:50, transformOrigin: "50% 50%" });
		TweenMax.to([this.refs.triangle, this.refs.rage, this.refs.click], 0.6, {
			scaleX: 1,
			scaleY: 1,
			ease: Back.easeOut,
			delay: 0.5,
			transformOrigin: "50% 50%",
			opacity: 1,
			y: 0,
			onComplete: () => {
				TweenMax.delayedCall(0.6, () => this.addHover())
			}
		});
	}

	addHover () {
		if (this.state.assetsLoaded === false) {
			TweenMax.delayedCall(1, () => this.addHover());
			return;
		}
		// console.log('adding hover stuff');
		TweenMax.to([this.refs.bottom], 0.75, {
			ease: Back.easeOut,
			transformOrigin: "50% 50%",
			autoAlpha: 1,
			delay: 0.2,
			y: 0
		})

		// add event listeners for start/click
		if (this.out) return; // abort if animating out already
		this.refs.click.addEventListener('mouseover', this.rageIn);
		this.refs.click.addEventListener('mouseout', this.rageOut);
		this.refs.click.addEventListener('click', this.rageGo);
		this.animateGlints();
	}

	animateGlints() {
		if (this.out) return;
		// TweenMax.set([this.refs.glint1, this.refs.glint2], {autoAlpha: 0});
		TweenMax.set([this.refs.glint1], {autoAlpha: 0.3});
		TweenMax.set([this.refs.glint2], {autoAlpha: 0.3, delay: 0.1});
		TweenMax.set([this.refs.glint3], {autoAlpha: 0.3, delay: 0.2});
		TweenMax.to(this.refs.glint3, 0.25, {x: 275, ease: Sine.easeOut, opacity: 0, delay: 0.2, onComplete: () => {
			TweenMax.set(this.refs.glint3, { x: 0});
		}});
		TweenMax.to(this.refs.glint2, 0.2, {x: 275, ease: Sine.easeOut, opacity: 0, delay: 0.1, onComplete: () => {
			TweenMax.set(this.refs.glint2, { x: 0});
		}});
		TweenMax.to(this.refs.glint1, 0.3, {x: 275, ease: Sine.easeOut, opacity: 0, onComplete: () => {
			TweenMax.set(this.refs.glint1, { x: 0});
		}});
		TweenMax.delayedCall(this.getRandomArbitrary(2, 5), () => this.animateGlints())
	}

	rageIn = (e) => {
		TweenMax.to([this.refs.triangle, this.refs.click, this.refs.rage], 0.2, {
			scaleX: 1.15,
			scaleY: 1.15,
			ease: Back.easeOut
		});
	}

	rageOut = (e) => {
		TweenMax.to([this.refs.triangle, this.refs.click, this.refs.rage], 0.5, {
			scaleX: 1,
			scaleY: 1,
			ease: Sine.easeOut
		});
	}

	rageGo = (e) => {
		e.stopImmediatePropagation();
		this.refs.click.removeEventListener('mouseover', this.rageIn);
		this.refs.click.removeEventListener('mouseout', this.rageOut);
		this.refs.click.removeEventListener('click', this.rageGo);

		TweenMax.delayedCall(1, () => this.props.playSndFx('startAnimateLogo'));
		TweenMax.to([this.refs.triangle, this.refs.click, this.refs.rage], 1, {
			scaleX: 1,
			scaleY: 1,
			ease: Sine.easeOut,
			onComplete: this.animateOut(true)
		});
	}

	getImagesToLoad() {
		let imageArray = [];
		for (var property in alltheimages) {
			imageArray.push(alltheimages[property]);
		}

		this.setState({
			imageArray: imageArray
		}, () => this.loadAllAssets())
	}

	isDone () {
		if (this.state.imageArray.length === this.state.successCount + this.state.errorCount) {
			this.setState({
				assetsLoaded: true,
				startScreenReady: true
			})
			this.props.gameMusic('soundscape');
			// console.log('assets loaded!');
			return true;
		}
		return false;
	}

	loadAllAssets() {
		// console.log('loadAllAssets!');
		let path = "";
		let img = null;

		return new Promise(resolve => {
			if (this.state.imageArray.length === 0 && this.state.soundQueue.length === 0) {
				resolve();
			}
			for (let i = 0; i < this.state.imageArray.length; i++) {
				path = this.state.imageArray[i];
				img = new Image();
				img.addEventListener(
					"load",
					e => {
						this.setState({
							successCount: this.state.successCount + 1
						}, () => {
							if (this.isDone()) resolve();
						})

					},
					false
				);

				img.addEventListener(
					"error",
					error => {
						this.assetLoaderErrorLog.push({
							assetType: "image",
							description:
								"Could not load image. The provided url may be invalid.",
							url: error.currentTarget.src
						});
						this.setState({
							errorCount: this.state.errorCount + 1
						}, () => {
							if (this.isDone()) resolve();
						})
					},
					false
				);

				img.src = path;
				this.cache[path] = img;
			}
		});
	}

	animateOut (play) {

		this.props.playSndFx('introClick');

		this.out = true;
		TweenMax.killAll( true, true, true, true);
		TweenMax.to(this.refs.bottom, 0.5, {autoAlpha: 0})
		let flames = this.refs.flames.childNodes;
		_.forEach(flames, (flame, index) => {
			TweenMax.to(flame , 0.25, {
				delay: (index * 0.01) + 0.15,
				autoAlpha:0,
				ease: Sine.easeOut,
				transformOrigin: "50% 50%"
			});
		});
		const logo = [this.refs.triangle, this.refs.rage, this.refs.click];
		_.forEach(logo, (el, index) => {
			TweenMax.to(el , 0.25, {
				scaleX: 0,
				scaleY: 0,
				ease: Back.easeIn,
				delay: 0.15 * index,
				opacity: 0,
				transformOrigin: "50% 50%",
				y: 50
			});
		});
		TweenMax.to(this.refs.startscreen, 0.3, { delay: 0.55, autoAlpha: 0, ease: Sine.easeIn})
		TweenMax.delayedCall(1.6, () => {
			TweenMax.killAll( true, true, true);
			this.props.deletePlaybackToken();
			if (play) this.props.router.push("/intro")
			// else this.props.router.push("/scores")
		})
	}

	quickJump (destination) {
		this.out = true;
		TweenMax.killAll( true, true, true, true);
		this.props.router.push(destination);
	}

	startAnimation = (option) => {
		this.props.audioChosen();
		// console.log(this.props);
		this.waitForLogo();
		if (option === 'yes') this.props.toggleMute();
	}

	waitForLogo () {
		TweenMax.delayedCall(5, () => this.animateLogo());
	}

	render() {
		return (
			<div className="startscreen" ref="startscreen">

				{/* COMMENT THIS OUT BEFORE GOING LIVE // TOGGLES DEBUG MENU VISABILITY */}
				{ this.props.showDebug &&
					<div className="debugMenu">
						<nav>
							<button onClick={e => this.quickJump("/intro")}>Intro</button>
							<button onClick={e => this.quickJump("/play")}>GamePlay</button>
							<button onClick={e => this.quickJump("/win")}>WinScreen</button>
							{/* <button onClick={e => this.quickJump("/scores")}>HighScores</button> */}
						</nav>
					</div>
				}
				{ this.props.audioSet !== true &&
					<AudioNotice
						callback={this.startAnimation}
						startScreenReady={ this.state.startScreenReady }
						successCount={this.state.successCount}
						imageCount={this.state.imageArray.length}
					/>
				}

				<div className="animatedBg">
					<Hud hideScore={true} />
					<svg version="1.1" id="start_screen" width="100%" height="100%" x="0px" y="0px" viewBox="0 0 1024 768" enableBackground="new 0 0 1024 768" preserveAspectRatio="xMidYMin slice">
						<rect id="SOLID" ref="sky" fill="#000000" width="1024" height="768"/>
						<rect id="ground" y="350" width="1024" height="418"/>
						<g id="back">
							<g>
								<polygon fill="#181610" points="494.613,323.607 435.542,332.629 430.064,303.216 489.603,295.198 		"/>
								<polygon fill="#181610" points="494.613,323.607 509.08,350.786 513.697,340.382 495.154,311.107 		"/>
								<polygon fill="#181610" points="435.542,332.629 411.668,343.539 415.355,377.305 439.456,364.811 		"/>
								<polygon fill="#181610" points="439.456,364.811 509.08,350.786 519.378,385.292 442.52,403.913 		"/>
								<polygon points="509.08,350.786 493.972,354.568 494.613,323.607 		"/>
								<polygon fill="#0C0A07" points="494.613,323.607 493.972,354.568 439.456,364.811 435.542,332.629 		"/>
							</g>
							<g>
								<polygon fill="#181610" points="383.947,320.545 434.174,334.303 441.621,305.325 390.859,292.538 		"/>
								<polygon fill="#181610" points="383.947,320.545 367.681,346.688 359.076,326.163 379.55,298.204 		"/>
								<polygon fill="#181610" points="434.174,334.303 443.159,316.469 433.755,361.247 428.1,366.147 		"/>
								<polygon fill="#181610" points="428.1,366.147 367.681,346.688 355.081,380.421 422.408,404.954 		"/>
								<polygon points="367.681,346.688 382.499,351.479 383.947,320.545 		"/>
								<polygon fill="#0C0A07" points="383.947,320.545 382.499,351.479 428.1,366.147 434.174,334.303 		"/>
							</g>
							<g>
								<polygon fill="#181610" points="358.099,326.903 310.227,326.335 309.731,302.37 357.842,303.793 		"/>
								<polygon fill="#181610" points="358.099,326.903 365.992,350.275 370.997,342.652 360.156,317.093 		"/>
								<polygon fill="#181610" points="310.227,326.335 289.933,331.847 288.446,359.02 309.126,352.285 		"/>
								<polygon fill="#181610" points="309.126,352.285 365.992,350.275 369.634,378.894 306.451,383.594 		"/>
								<polygon points="365.992,350.275 353.556,351.295 358.099,326.903 		"/>
								<polygon fill="#0C0A07" points="358.099,326.903 353.556,351.295 309.126,352.285 310.227,326.335 		"/>
							</g>
							<g>
								<polygon points="262.18,366.381 262.001,399.972 294.257,361.184 296.445,333.142 		"/>
								<polygon fill="#0C0A07" points="262.18,366.381 217.982,343.308 222.116,373.812 262.001,399.972 		"/>
								<g>
									<polygon fill="#181610" points="296.445,333.142 257.579,316.869 271.295,290.324 311.038,305.686 			"/>
									<polygon fill="#181610" points="257.579,316.869 217.982,343.308 201.261,319.971 243.081,296.634 			"/>
									<polygon fill="#181610" points="296.445,333.142 262.18,366.381 274.308,360.982 303.972,330.642 			"/>
									<path fill="#181610" d="M262.18,366.381c-0.56-0.022-44.198-23.073-44.198-23.073l-22.586-6.371l54.444,29.65L262.18,366.381z"/>
									<polygon fill="#0C0A07" points="257.579,316.869 258.883,348.137 247.182,358.663 217.982,343.308 			"/>
									<polygon points="258.883,348.137 273.812,355.096 296.445,333.142 257.579,316.869 			"/>
									<polygon fill="#241B0D" points="258.883,348.137 247.182,358.663 262.18,366.381 273.812,355.096 			"/>
								</g>
							</g>
							<g>
								<polygon fill="#181610" points="215.563,322.913 155.811,322.204 155.192,292.291 215.243,294.068 		"/>
								<polygon fill="#181610" points="215.563,322.913 225.415,352.084 231.663,342.57 218.131,310.668 		"/>
								<polygon fill="#181610" points="155.811,322.204 130.481,329.084 128.624,363 154.437,354.593 		"/>
								<polygon fill="#181610" points="154.437,354.593 225.415,352.084 229.962,387.806 151.098,393.673 		"/>
								<polygon points="225.415,352.084 209.893,353.358 215.563,322.913 		"/>
								<polygon fill="#0C0A07" points="215.563,322.913 209.893,353.358 154.437,354.593 155.811,322.204 		"/>
							</g>
							<g>
								<polygon fill="#0C0A07" points="58.117,368.944 55.093,405.383 -4.237,388.785 -3.996,355.516 		"/>
								<polygon points="58.117,368.944 72.729,327.97 69.119,359.542 55.093,405.383 		"/>
								<g>
									<polygon fill="#181610" points="72.729,327.97 76.625,302.894 24.789,295.19 21.197,319.497 			"/>
									<polygon fill="#181610" points="21.197,319.497 -3.996,355.516 -28.808,340.147 0.41,305.071 			"/>
									<polygon fill="#181610" points="72.729,327.97 58.117,368.944 66.31,363.335 80.036,321.076 			"/>
									<polygon fill="#181610" points="58.117,368.944 -3.996,355.516 -16.188,355.652 55.347,371.801 			"/>
									<polygon points="72.729,327.97 61.751,358.756 23.533,349.863 21.197,319.497 			"/>
									<polygon fill="#0C0A07" points="21.197,319.497 23.533,349.863 17.284,360.115 -3.996,355.516 			"/>
									<polygon fill="#241B0D" points="23.533,349.863 61.751,358.756 58.117,368.944 17.284,360.115 			"/>
								</g>
							</g>
							<g>
								<polygon fill="#0C0A07" points="644.307,361.12 640.52,406.758 566.212,385.97 566.513,344.303 		"/>
								<polygon points="644.307,361.12 662.606,309.803 658.085,349.345 640.52,406.758 		"/>
								<g>
									<polygon fill="#181610" points="662.606,309.803 667.486,278.397 602.565,268.748 598.066,299.192 			"/>
									<polygon fill="#181610" points="598.066,299.192 566.513,344.303 535.438,325.054 572.032,281.124 			"/>
									<polygon fill="#181610" points="662.606,309.803 644.307,361.12 654.568,354.096 671.758,301.169 			"/>
									<polygon fill="#181610" points="644.307,361.12 566.513,344.303 551.244,344.473 640.837,364.699 			"/>
									<polygon points="662.606,309.803 648.858,348.361 600.993,337.222 598.066,299.192 			"/>
									<polygon fill="#0C0A07" points="598.066,299.192 600.993,337.222 593.165,350.063 566.513,344.303 			"/>
									<polygon fill="#241B0D" points="600.993,337.222 648.858,348.361 644.307,361.12 593.165,350.063 			"/>
								</g>
							</g>
							<g>
								<polygon fill="#181610" points="827.969,322.101 768.218,321.392 767.598,291.479 827.649,293.255 		"/>
								<polygon fill="#181610" points="827.969,322.101 837.821,351.272 844.069,341.758 830.537,309.856 		"/>
								<polygon fill="#181610" points="768.218,321.392 742.887,328.271 741.03,362.187 766.843,353.781 		"/>
								<polygon fill="#181610" points="766.843,353.781 837.821,351.272 842.368,386.993 763.504,392.861 		"/>
								<polygon points="837.821,351.272 822.3,352.546 827.969,322.101 		"/>
								<polygon fill="#0C0A07" points="827.969,322.101 822.3,352.546 766.843,353.781 768.218,321.392 		"/>
							</g>
							<g>
								<polygon points="100.244,366.055 100.065,399.646 132.321,360.858 134.509,332.816 		"/>
								<polygon fill="#0C0A07" points="100.244,366.055 56.046,342.982 60.18,373.486 100.065,399.646 		"/>
								<g>
									<polygon fill="#181610" points="134.509,332.816 95.643,316.543 109.359,289.998 149.102,305.36 			"/>
									<polygon fill="#181610" points="95.643,316.543 56.046,342.982 39.325,319.645 81.145,296.308 			"/>
									<polygon fill="#181610" points="134.509,332.816 100.244,366.055 112.372,360.656 142.036,330.315 			"/>
									<path fill="#181610" d="M100.244,366.055c-0.56-0.022-44.198-23.073-44.198-23.073l-22.586-6.371l54.444,29.65L100.244,366.055z"
										/>
									<polygon fill="#0C0A07" points="95.643,316.543 96.947,347.81 85.246,358.337 56.046,342.982 			"/>
									<polygon points="96.947,347.81 111.876,354.77 134.509,332.816 95.643,316.543 			"/>
									<polygon fill="#241B0D" points="96.947,347.81 85.246,358.337 100.244,366.055 111.876,354.77 			"/>
								</g>
							</g>
							<g>
								<polygon fill="#0C0A07" points="674.972,509.948 675.065,545.355 733.62,533.936 735.967,501.804 		"/>
								<polygon points="674.972,509.948 664.046,469.266 665.082,500.02 675.065,545.355 		"/>
								<g>
									<polygon fill="#181610" points="664.046,469.266 662.23,444.759 712.861,441.343 714.443,465.084 			"/>
									<polygon fill="#181610" points="714.443,465.084 735.967,501.804 761.108,488.893 735.627,452.771 			"/>
									<polygon fill="#181610" points="664.046,469.266 674.972,509.948 667.498,503.899 657.528,462.045 			"/>
									<polygon fill="#181610" points="674.972,509.948 735.967,501.804 747.725,502.881 677.425,512.921 			"/>
									<polygon points="664.046,469.266 672.255,499.833 709.833,494.213 714.443,465.084 			"/>
									<polygon fill="#0C0A07" points="714.443,465.084 709.833,494.213 715.07,504.594 735.967,501.804 			"/>
									<polygon fill="#241B0D" points="709.833,494.213 672.255,499.833 674.972,509.948 715.07,504.594 			"/>
								</g>
							</g>
							<g>
								<polygon fill="#181610" points="172.5,413.8 222.727,427.558 230.175,398.58 179.413,385.793 		"/>
								<polygon fill="#181610" points="172.5,413.8 156.234,439.943 147.63,419.418 168.103,391.459 		"/>
								<polygon fill="#181610" points="222.727,427.558 231.713,409.724 222.308,454.502 216.653,459.403 		"/>
								<polygon fill="#181610" points="216.653,459.403 156.234,439.943 143.634,473.676 210.962,498.21 		"/>
								<polygon points="156.234,439.943 171.053,444.734 172.5,413.8 		"/>
								<polygon fill="#0C0A07" points="172.5,413.8 171.053,444.734 216.653,459.403 222.727,427.558 		"/>
							</g>
							<polygon fill="#181610" points="637.17,466.494 577.418,465.785 576.799,435.872 636.85,437.648 	"/>
							<polygon fill="#181610" points="637.17,466.494 647.022,495.665 653.27,486.151 639.738,454.249 	"/>
							<polygon fill="#181610" points="577.418,465.785 552.088,472.665 550.231,506.581 576.044,498.174 	"/>
							<polygon fill="#181610" points="576.044,498.174 647.022,495.665 651.569,531.387 572.705,537.254 	"/>
							<polygon points="647.022,495.665 631.5,496.939 637.17,466.494 	"/>
							<polygon fill="#0C0A07" points="637.17,466.494 631.5,496.939 576.044,498.174 577.418,465.785 	"/>
							<polygon points="118.929,464.537 118.75,498.127 151.006,459.34 153.193,431.298 	"/>
							<polygon fill="#0C0A07" points="118.929,464.537 74.731,441.464 78.865,471.967 118.75,498.127 	"/>
							<g>
								<polygon fill="#181610" points="153.193,431.298 114.328,415.025 128.044,388.48 167.786,403.842 		"/>
								<polygon fill="#181610" points="114.328,415.025 74.731,441.464 58.01,418.126 99.83,394.79 		"/>
								<polygon fill="#181610" points="153.193,431.298 118.929,464.537 131.057,459.137 160.721,428.797 		"/>
								<path fill="#181610" d="M118.929,464.537c-0.56-0.022-44.198-23.073-44.198-23.073l-22.586-6.371l54.444,29.65L118.929,464.537z"
									/>
								<polygon fill="#0C0A07" points="114.328,415.025 115.631,446.292 103.931,456.819 74.731,441.464 		"/>
								<polygon points="115.631,446.292 130.561,453.252 153.193,431.298 114.328,415.025 		"/>
								<polygon fill="#241B0D" points="115.631,446.292 103.931,456.819 118.929,464.537 130.561,453.252 		"/>
							</g>
							<polygon fill="#0C0A07" points="871.216,393.296 871.309,428.702 929.864,417.283 932.212,385.151 	"/>
							<polygon points="871.216,393.296 860.291,352.613 861.326,383.367 871.309,428.702 	"/>
							<g>
								<polygon fill="#181610" points="860.291,352.613 858.474,328.106 909.106,324.69 910.688,348.431 		"/>
								<polygon fill="#181610" points="910.688,348.431 932.212,385.151 957.353,372.241 931.871,336.118 		"/>
								<polygon fill="#181610" points="860.291,352.613 871.216,393.296 863.743,387.247 853.772,345.392 		"/>
								<polygon fill="#181610" points="871.216,393.296 932.212,385.151 943.969,386.228 873.669,396.268 		"/>
								<polygon points="860.291,352.613 868.499,383.18 906.078,377.56 910.688,348.431 		"/>
								<polygon fill="#0C0A07" points="910.688,348.431 906.078,377.56 911.315,387.941 932.212,385.151 		"/>
								<polygon fill="#241B0D" points="906.078,377.56 868.499,383.18 871.216,393.296 911.315,387.941 		"/>
							</g>
							<polygon fill="#181610" points="588.751,345.148 638.978,358.906 646.426,329.928 595.663,317.141 	"/>
							<polygon fill="#181610" points="588.751,345.148 572.485,371.291 563.881,350.767 584.354,322.808 	"/>
							<polygon fill="#181610" points="638.978,358.906 647.964,341.072 638.559,385.85 632.904,390.751 	"/>
							<polygon fill="#181610" points="632.904,390.751 572.485,371.291 559.885,405.024 627.213,429.558 	"/>
							<polygon points="572.485,371.291 587.304,376.082 588.751,345.148 	"/>
							<polygon fill="#0C0A07" points="588.751,345.148 587.304,376.082 632.904,390.751 638.978,358.906 	"/>
							<polygon fill="#181610" points="819.934,378.993 760.182,378.284 759.563,348.371 819.613,350.147 	"/>
							<polygon fill="#181610" points="819.934,378.993 829.785,408.164 836.034,398.65 822.501,366.748 	"/>
							<polygon fill="#181610" points="760.182,378.284 734.851,385.164 732.995,419.08 758.808,410.673 	"/>
							<polygon fill="#181610" points="758.808,410.673 829.785,408.164 834.332,443.886 755.468,449.753 	"/>
							<polygon points="829.785,408.164 814.264,409.438 819.934,378.993 	"/>
							<polygon fill="#0C0A07" points="819.934,378.993 814.264,409.438 758.808,410.673 760.182,378.284 	"/>
							<polygon fill="#0C0A07" points="724.137,373.753 721.113,410.191 661.783,393.594 662.024,360.325 	"/>
							<polygon points="724.137,373.753 738.748,332.779 735.138,364.351 721.113,410.191 	"/>
							<g>
								<polygon fill="#181610" points="738.748,332.779 742.645,307.702 690.809,299.999 687.217,324.306 		"/>
								<polygon fill="#181610" points="687.217,324.306 662.024,360.325 637.212,344.955 666.429,309.88 		"/>
								<polygon fill="#181610" points="738.748,332.779 724.137,373.753 732.33,368.144 746.056,325.885 		"/>
								<polygon fill="#181610" points="724.137,373.753 662.024,360.325 649.831,360.461 721.366,376.61 		"/>
								<polygon points="738.748,332.779 727.771,363.565 689.553,354.671 687.217,324.306 		"/>
								<polygon fill="#0C0A07" points="687.217,324.306 689.553,354.671 683.304,364.924 662.024,360.325 		"/>
								<polygon fill="#241B0D" points="689.553,354.671 727.771,363.565 724.137,373.753 683.304,364.924 		"/>
							</g>
							<g>
								<polygon fill="#0C0A07" points="970.125,464.521 967.101,500.959 907.771,484.362 908.011,451.093 		"/>
								<polygon points="970.125,464.521 984.736,423.547 981.126,455.119 967.101,500.959 		"/>
								<g>
									<polygon fill="#181610" points="984.736,423.547 988.632,398.47 936.796,390.767 933.204,415.074 			"/>
									<polygon fill="#181610" points="933.204,415.074 908.011,451.093 883.2,435.723 912.417,400.648 			"/>
									<polygon fill="#181610" points="984.736,423.547 970.125,464.521 978.318,458.912 992.043,416.653 			"/>
									<polygon fill="#181610" points="970.125,464.521 908.011,451.093 895.819,451.229 967.354,467.378 			"/>
									<polygon points="984.736,423.547 973.758,454.333 935.541,445.439 933.204,415.074 			"/>
									<polygon fill="#0C0A07" points="933.204,415.074 935.541,445.439 929.291,455.692 908.011,451.093 			"/>
									<polygon fill="#241B0D" points="935.541,445.439 973.758,454.333 970.125,464.521 929.291,455.692 			"/>
								</g>
							</g>
							<g>
								<polygon fill="#181610" points="810.049,446.136 860.276,459.894 867.723,430.916 816.961,418.129 		"/>
								<polygon fill="#181610" points="810.049,446.136 793.783,472.279 785.178,451.755 805.652,423.796 		"/>
								<polygon fill="#181610" points="860.276,459.894 869.261,442.06 859.857,486.838 854.202,491.739 		"/>
								<polygon fill="#181610" points="854.202,491.739 793.783,472.279 781.183,506.012 848.51,530.546 		"/>
								<polygon points="793.783,472.279 808.601,477.07 810.049,446.136 		"/>
								<polygon fill="#0C0A07" points="810.049,446.136 808.601,477.07 854.202,491.739 860.276,459.894 		"/>
							</g>
							<g>
								<polygon fill="#0C0A07" points="280.753,493.454 280.846,528.86 339.401,517.441 341.749,485.309 		"/>
								<g>
									<polygon points="280.753,493.454 269.828,452.771 270.864,483.525 280.846,528.86 			"/>
									<g>
										<polygon fill="#181610" points="269.828,452.771 268.012,428.264 318.643,424.849 320.225,448.59 				"/>
										<polygon fill="#181610" points="320.225,448.59 341.749,485.309 366.89,472.399 341.408,436.277 				"/>
										<polygon fill="#181610" points="269.828,452.771 280.753,493.454 273.28,487.405 263.309,445.55 				"/>
										<polygon fill="#181610" points="280.753,493.454 341.749,485.309 353.507,486.386 283.206,496.427 				"/>
										<polygon points="269.828,452.771 278.036,483.338 315.615,477.718 320.225,448.59 				"/>
										<polygon fill="#0C0A07" points="320.225,448.59 315.615,477.718 320.852,488.099 341.749,485.309 				"/>
										<polygon fill="#241B0D" points="315.615,477.718 278.036,483.338 280.753,493.454 320.852,488.099 				"/>
									</g>
								</g>
							</g>
							<polygon fill="#0C0A07" points="479.063,402.19 479.156,437.597 537.71,426.177 540.058,394.046 	"/>
							<polygon points="479.063,402.19 468.137,361.508 469.173,392.262 479.156,437.597 	"/>
							<g>
								<polygon fill="#181610" points="468.137,361.508 466.321,337.001 516.952,333.585 518.534,357.326 		"/>
								<polygon fill="#181610" points="518.534,357.326 540.058,394.046 565.199,381.135 539.718,345.013 		"/>
								<polygon fill="#181610" points="468.137,361.508 479.063,402.19 471.589,396.141 461.618,354.287 		"/>
								<polygon fill="#181610" points="479.063,402.19 540.058,394.046 551.816,395.123 481.515,405.163 		"/>
								<polygon points="468.137,361.508 476.346,392.075 513.924,386.454 518.534,357.326 		"/>
								<polygon fill="#0C0A07" points="518.534,357.326 513.924,386.454 519.161,396.835 540.058,394.046 		"/>
								<polygon fill="#241B0D" points="513.924,386.454 476.346,392.075 479.063,402.19 519.161,396.835 		"/>
							</g>
							<g>
								<polygon fill="#181610" points="360.235,402.929 300.483,402.22 299.864,372.307 359.915,374.084 		"/>
								<polygon fill="#181610" points="360.235,402.929 370.087,432.101 376.335,422.586 362.803,390.684 		"/>
								<polygon fill="#181610" points="300.483,402.22 275.153,409.1 273.296,443.016 299.109,434.61 		"/>
								<polygon fill="#181610" points="299.109,434.61 370.087,432.101 374.634,467.822 295.769,473.689 		"/>
								<polygon points="370.087,432.101 354.565,433.374 360.235,402.929 		"/>
								<polygon fill="#0C0A07" points="360.235,402.929 354.565,433.374 299.109,434.61 300.483,402.22 		"/>
							</g>
							<polygon fill="#0C0A07" points="66.9,429.482 63.876,465.92 4.546,449.323 4.787,416.053 	"/>
							<polygon points="66.9,429.482 81.511,388.508 77.902,420.08 63.876,465.92 	"/>
							<g>
								<polygon fill="#181610" points="81.511,388.508 85.408,363.431 33.572,355.728 29.98,380.035 		"/>
								<polygon fill="#181610" points="29.98,380.035 4.787,416.053 -20.025,400.684 9.193,365.609 		"/>
								<polygon fill="#181610" points="81.511,388.508 66.9,429.482 75.093,423.873 88.819,381.614 		"/>
								<polygon fill="#181610" points="66.9,429.482 4.787,416.053 -7.405,416.189 64.13,432.339 		"/>
								<polygon points="81.511,388.508 70.534,419.293 32.316,410.4 29.98,380.035 		"/>
								<polygon fill="#0C0A07" points="29.98,380.035 32.316,410.4 26.067,420.653 4.787,416.053 		"/>
								<polygon fill="#241B0D" points="32.316,410.4 70.534,419.293 66.9,429.482 26.067,420.653 		"/>
							</g>
							<polygon fill="#0C0A07" points="623.706,457.906 619.918,503.544 545.611,482.756 545.912,441.089 	"/>
							<polygon points="623.706,457.906 642.005,406.589 637.484,446.131 619.918,503.544 	"/>
							<g>
								<polygon fill="#181610" points="642.005,406.589 646.885,375.183 581.964,365.534 577.465,395.978 		"/>
								<polygon fill="#181610" points="577.465,395.978 545.912,441.089 514.837,421.84 551.43,377.909 		"/>
								<polygon fill="#181610" points="642.005,406.589 623.706,457.906 633.967,450.882 651.157,397.955 		"/>
								<polygon fill="#181610" points="623.706,457.906 545.912,441.089 530.642,441.259 620.235,461.485 		"/>
								<polygon points="642.005,406.589 628.256,445.146 580.391,434.008 577.465,395.978 		"/>
								<polygon fill="#0C0A07" points="577.465,395.978 580.391,434.008 572.564,446.849 545.912,441.089 		"/>
								<polygon fill="#241B0D" points="580.391,434.008 628.256,445.146 623.706,457.906 572.564,446.849 		"/>
							</g>
							<g>
								<polygon fill="#181610" points="235.341,383.024 285.568,396.782 293.015,367.805 242.253,355.017 		"/>
								<polygon fill="#181610" points="235.341,383.024 219.075,409.167 210.47,388.643 230.944,360.684 		"/>
								<polygon fill="#181610" points="285.568,396.782 294.553,378.948 285.149,423.726 279.494,428.627 		"/>
								<polygon fill="#181610" points="279.494,428.627 219.075,409.167 206.475,442.9 273.802,467.434 		"/>
								<polygon points="219.075,409.167 233.893,413.959 235.341,383.024 		"/>
								<polygon fill="#0C0A07" points="235.341,383.024 233.893,413.959 279.494,428.627 285.568,396.782 		"/>
							</g>
							<g>
								<polygon fill="#0C0A07" points="849.835,415.713 849.928,451.12 908.482,439.701 910.83,407.569 		"/>
								<polygon points="849.835,415.713 838.909,375.031 839.945,405.785 849.928,451.12 		"/>
								<g>
									<polygon fill="#181610" points="838.909,375.031 837.093,350.524 887.724,347.108 889.306,370.849 			"/>
									<polygon fill="#181610" points="889.306,370.849 910.83,407.569 935.971,394.658 910.49,358.536 			"/>
									<polygon fill="#181610" points="838.909,375.031 849.835,415.713 842.361,409.664 832.39,367.81 			"/>
									<polygon fill="#181610" points="849.835,415.713 910.83,407.569 922.588,408.646 852.287,418.686 			"/>
									<polygon points="838.909,375.031 847.118,405.598 884.696,399.978 889.306,370.849 			"/>
									<polygon fill="#0C0A07" points="889.306,370.849 884.696,399.978 889.933,410.359 910.83,407.569 			"/>
									<polygon fill="#241B0D" points="884.696,399.978 847.118,405.598 849.835,415.713 889.933,410.359 			"/>
								</g>
							</g>
							<polygon fill="#181610" points="510.711,317.812 560.938,331.57 568.386,302.592 517.623,289.805 	"/>
							<polygon fill="#181610" points="510.711,317.812 494.445,343.955 485.84,323.43 506.314,295.471 	"/>
							<polygon fill="#181610" points="560.938,331.57 569.924,313.736 560.519,358.514 554.864,363.414 	"/>
							<polygon fill="#181610" points="554.864,363.414 494.445,343.955 481.845,377.688 549.173,402.221 	"/>
							<polygon points="494.445,343.955 509.263,348.746 510.711,317.812 	"/>
							<polygon fill="#0C0A07" points="510.711,317.812 509.263,348.746 554.864,363.414 560.938,331.57 	"/>
							<polygon fill="#0C0A07" points="692.646,433.186 689.622,469.625 630.292,453.028 630.532,419.758 	"/>
							<polygon points="692.646,433.186 707.257,392.212 703.647,423.784 689.622,469.625 	"/>
							<g>
								<polygon fill="#181610" points="707.257,392.212 711.153,367.136 659.317,359.432 655.725,383.74 		"/>
								<polygon fill="#181610" points="655.725,383.74 630.532,419.758 605.721,404.389 634.938,369.313 		"/>
								<polygon fill="#181610" points="707.257,392.212 692.646,433.186 700.839,427.578 714.565,385.319 		"/>
								<polygon fill="#181610" points="692.646,433.186 630.532,419.758 618.34,419.894 689.875,436.044 		"/>
								<polygon points="707.257,392.212 696.279,422.998 658.062,414.105 655.725,383.74 		"/>
								<polygon fill="#0C0A07" points="655.725,383.74 658.062,414.105 651.812,424.358 630.532,419.758 		"/>
								<polygon fill="#241B0D" points="658.062,414.105 696.279,422.998 692.646,433.186 651.812,424.358 		"/>
							</g>
							<g display="none">
								<polygon display="inline" points="286.031,305.698 287.198,339.269 317.874,299.22 318.936,271.113 		"/>
								<polygon display="inline" fill="#0C0A07" points="286.031,305.698 240.944,284.415 246.297,314.728 287.198,339.269 		"/>
								<polygon display="inline" fill="#181610" points="318.936,271.113 279.45,256.41 292.091,229.337 332.417,243.094 		"/>
								<polygon display="inline" fill="#181610" points="279.45,256.41 240.944,284.415 223.301,261.766 264.152,236.772 		"/>
								<polygon display="inline" fill="#181610" points="318.936,271.113 286.031,305.698 297.933,299.817 326.357,268.312 		"/>
								<path display="inline" fill="#181610" d="M286.031,305.698c-0.56,0-45.087-21.283-45.087-21.283l-22.824-5.461l55.589,27.444
									L286.031,305.698z"/>
								<polygon display="inline" fill="#0C0A07" points="279.45,256.41 282.005,287.6 270.736,298.587 240.944,284.415 		"/>
								<polygon display="inline" points="282.005,287.6 297.201,293.956 318.936,271.113 279.45,256.41 		"/>
								<polygon display="inline" fill="#241B0D" points="282.005,287.6 270.736,298.587 286.031,305.698 297.201,293.956 		"/>
							</g>
							<polygon fill="#181610" points="977.658,350.877 1027.885,364.635 1035.333,335.657 984.571,322.87 	"/>
							<polygon fill="#181610" points="977.658,350.877 961.393,377.02 952.788,356.496 973.261,328.537 	"/>
							<polygon fill="#181610" points="1027.885,364.635 1036.871,346.801 1027.466,391.579 1021.811,396.48 	"/>
							<polygon fill="#181610" points="1021.811,396.48 961.393,377.02 948.792,410.753 1016.12,435.287 	"/>
							<polygon points="961.393,377.02 976.211,381.811 977.658,350.877 	"/>
							<polygon fill="#0C0A07" points="977.658,350.877 976.211,381.811 1021.811,396.48 1027.885,364.635 	"/>
							<polygon fill="#0C0A07" points="465.043,426.765 465.136,462.172 523.69,450.753 526.038,418.621 	"/>
							<polygon points="465.043,426.765 454.117,386.083 455.153,416.837 465.136,462.172 	"/>
							<g>
								<polygon fill="#181610" points="454.117,386.083 452.301,361.576 502.932,358.16 504.514,381.901 		"/>
								<polygon fill="#181610" points="504.514,381.901 526.038,418.621 551.179,405.71 525.698,369.588 		"/>
								<polygon fill="#181610" points="454.117,386.083 465.043,426.765 457.569,420.716 447.598,378.862 		"/>
								<polygon fill="#181610" points="465.043,426.765 526.038,418.621 537.796,419.698 467.496,429.738 		"/>
								<polygon points="454.117,386.083 462.326,416.65 499.904,411.03 504.514,381.901 		"/>
								<polygon fill="#0C0A07" points="504.514,381.901 499.904,411.03 505.141,421.411 526.038,418.621 		"/>
								<polygon fill="#241B0D" points="499.904,411.03 462.326,416.65 465.043,426.765 505.141,421.411 		"/>
							</g>
						</g>
						<g id="mid">
							<polygon fill="#15120C" points="657.101,653.183 659.535,710.139 753.001,687.99 754.704,636.145 	"/>
							<polygon fill="#050402" points="657.101,653.183 636.898,588.439 640.549,637.849 659.535,710.139 	"/>
							<g>
								<polygon fill="#262015" points="636.898,588.439 632.395,549.13 713.63,540.367 717.707,578.459 		"/>
								<polygon fill="#262015" points="717.707,578.459 754.704,636.145 794.318,613.753 750.992,557.283 		"/>
								<polygon fill="#262015" points="636.898,588.439 657.101,653.183 644.687,643.934 625.945,577.242 		"/>
								<polygon fill="#262015" points="657.101,653.183 754.704,636.145 773.69,637.119 661.238,657.808 		"/>
								<polygon fill="#050402" points="636.898,588.439 652.077,637.085 712.17,625.618 717.707,578.459 		"/>
								<polygon fill="#15120C" points="717.707,578.459 712.17,625.618 721.265,641.981 754.704,636.145 		"/>
								<polygon fill="#36260D" points="712.17,625.618 652.077,637.085 657.101,653.183 721.265,641.981 		"/>
							</g>
							<polygon fill="#262015" points="216.309,526.971 298.002,545.864 308.114,498.764 225.623,481.468 	"/>
							<polygon fill="#262015" points="216.309,526.971 191.828,570.079 176.66,537.615 207.794,491.313 	"/>
							<polygon fill="#262015" points="298.002,545.864 311.307,516.593 299.067,589.238 290.285,597.487 	"/>
							<polygon fill="#262015" points="290.285,597.487 191.828,570.079 173.733,625.162 283.633,660.287 	"/>
							<polygon fill="#050402" points="191.828,570.079 215.977,576.831 216.309,526.971 	"/>
							<polygon fill="#15120C" points="216.309,526.971 215.977,576.831 290.285,597.487 298.002,545.864 	"/>
							<polygon fill="#262015" points="590.419,566.503 494.245,569.218 491.319,521.134 588.043,520.117 	"/>
							<polygon fill="#262015" points="590.419,566.503 608.151,612.798 617.589,597.088 593.76,546.637 	"/>
							<polygon fill="#262015" points="494.245,569.218 453.937,581.921 453.139,636.604 494.124,621.415 	"/>
							<polygon fill="#262015" points="494.124,621.415 608.151,612.798 617.771,669.973 491.273,684.502 	"/>
							<polygon fill="#050402" points="608.151,612.798 583.262,615.848 590.419,566.503 	"/>
							<polygon fill="#15120C" points="590.419,566.503 583.262,615.848 494.124,621.415 494.245,569.218 	"/>
							<polygon fill="#050402" points="89.768,589.803 91.647,643.856 141.038,579.373 142.748,534.118 	"/>
							<polygon fill="#15120C" points="89.768,589.803 17.174,555.535 25.792,604.343 91.647,643.856 	"/>
							<g>
								<polygon fill="#262015" points="142.748,534.118 79.172,510.446 99.525,466.855 164.454,489.005 		"/>
								<polygon fill="#262015" points="79.172,510.446 17.174,555.535 -11.233,519.069 54.541,478.827 		"/>
								<polygon fill="#262015" points="142.748,534.118 89.768,589.803 108.931,580.334 154.696,529.609 		"/>
								<path fill="#262015" d="M89.768,589.803c-0.902,0-72.594-34.268-72.594-34.268l-36.748-8.792l89.503,44.188L89.768,589.803z"/>
								<polygon fill="#15120C" points="79.172,510.446 83.286,560.664 65.141,578.355 17.174,555.535 		"/>
								<polygon fill="#050402" points="83.286,560.664 107.753,570.897 142.748,534.118 79.172,510.446 		"/>
								<polygon fill="#36260D" points="83.286,560.664 65.141,578.355 89.768,589.803 107.753,570.897 		"/>
							</g>
							<polygon fill="#15120C" points="921.297,505.271 923.731,562.227 1017.197,540.077 1018.901,488.233 	"/>
							<polygon fill="#050402" points="921.297,505.271 901.095,440.526 904.746,489.936 923.731,562.227 	"/>
							<g>
								<polygon fill="#262015" points="901.095,440.526 896.592,401.217 977.827,392.454 981.904,430.547 		"/>
								<polygon fill="#262015" points="981.904,430.547 1018.901,488.233 1058.514,465.84 1015.189,409.371 		"/>
								<polygon fill="#262015" points="901.095,440.526 921.297,505.271 908.884,496.021 890.142,429.33 		"/>
								<polygon fill="#262015" points="921.297,505.271 1018.901,488.233 1037.886,489.206 925.435,509.895 		"/>
								<polygon fill="#050402" points="901.095,440.526 916.273,489.172 976.367,477.705 981.904,430.547 		"/>
								<polygon fill="#15120C" points="981.904,430.547 976.367,477.705 985.462,494.068 1018.901,488.233 		"/>
								<polygon fill="#36260D" points="976.367,477.705 916.273,489.172 921.297,505.271 985.462,494.068 		"/>
							</g>
							<polygon fill="#15120C" points="141.717,571.094 144.151,628.05 237.617,605.901 239.321,554.056 	"/>
							<polygon fill="#050402" points="141.717,571.094 121.515,506.349 125.166,555.76 144.151,628.05 	"/>
							<g>
								<polygon fill="#262015" points="121.515,506.349 117.012,467.04 198.247,458.278 202.324,496.37 		"/>
								<polygon fill="#262015" points="202.324,496.37 239.321,554.056 278.934,531.663 235.609,475.194 		"/>
								<polygon fill="#262015" points="121.515,506.349 141.717,571.094 129.304,561.845 110.562,495.153 		"/>
								<polygon fill="#262015" points="141.717,571.094 239.321,554.056 258.306,555.03 145.855,575.719 		"/>
								<polygon fill="#050402" points="121.515,506.349 136.693,554.995 196.787,543.529 202.324,496.37 		"/>
								<polygon fill="#15120C" points="202.324,496.37 196.787,543.529 205.882,559.892 239.321,554.056 		"/>
								<polygon fill="#36260D" points="196.787,543.529 136.693,554.995 141.717,571.094 205.882,559.892 		"/>
							</g>
							<polygon fill="#15120C" points="-27.592,556.21 -25.158,613.166 68.308,591.016 70.012,539.172 	"/>
							<polygon fill="#050402" points="-27.592,556.21 -47.794,491.465 -44.143,540.876 -25.158,613.166 	"/>
							<g>
								<polygon fill="#262015" points="-47.794,491.465 -52.297,452.156 28.938,443.393 33.015,481.486 		"/>
								<polygon fill="#262015" points="33.015,481.486 70.012,539.172 109.625,516.779 66.3,460.31 		"/>
								<polygon fill="#262015" points="-47.794,491.465 -27.592,556.21 -40.005,546.961 -58.747,480.269 		"/>
								<polygon fill="#262015" points="-27.592,556.21 70.012,539.172 88.997,540.145 -23.454,560.834 		"/>
								<polygon fill="#050402" points="-47.794,491.465 -32.616,540.111 27.477,528.645 33.015,481.486 		"/>
								<polygon fill="#15120C" points="33.015,481.486 27.477,528.645 36.573,545.008 70.012,539.172 		"/>
								<polygon fill="#36260D" points="27.477,528.645 -32.616,540.111 -27.592,556.21 36.573,545.008 		"/>
							</g>
							<polygon fill="#262015" points="497.251,433.944 578.944,452.837 589.056,405.737 506.564,388.441 	"/>
							<polygon fill="#262015" points="497.251,433.944 472.77,477.052 457.602,444.588 488.736,398.286 	"/>
							<polygon fill="#262015" points="578.944,452.837 592.249,423.566 580.008,496.211 571.227,504.461 	"/>
							<polygon fill="#262015" points="571.227,504.461 472.77,477.052 454.675,532.135 564.574,567.26 	"/>
							<polygon fill="#050402" points="472.77,477.052 496.918,483.804 497.251,433.944 	"/>
							<polygon fill="#15120C" points="497.251,433.944 496.918,483.804 571.227,504.461 578.944,452.837 	"/>
							<polygon fill="#262015" points="878.803,413.939 782.629,416.654 779.703,368.569 876.426,367.553 	"/>
							<polygon fill="#262015" points="878.803,413.939 896.535,460.234 905.973,444.524 882.143,394.073 	"/>
							<polygon fill="#262015" points="782.629,416.654 742.321,429.356 741.523,484.04 782.508,468.851 	"/>
							<polygon fill="#262015" points="782.508,468.851 896.535,460.234 906.155,517.409 779.657,531.937 	"/>
							<polygon fill="#050402" points="896.535,460.234 871.646,463.284 878.803,413.939 	"/>
							<polygon fill="#15120C" points="878.803,413.939 871.646,463.284 782.508,468.851 782.629,416.654 	"/>
							<polygon fill="#262015" points="912.292,490.686 816.118,493.401 813.192,445.317 909.916,444.3 	"/>
							<polygon fill="#262015" points="912.292,490.686 930.024,536.981 939.463,521.271 915.633,470.82 	"/>
							<polygon fill="#262015" points="816.118,493.401 775.811,506.104 775.012,560.787 815.998,545.598 	"/>
							<polygon fill="#262015" points="815.998,545.598 930.024,536.981 939.644,594.156 813.146,608.685 	"/>
							<polygon fill="#050402" points="930.024,536.981 905.136,540.031 912.292,490.686 	"/>
							<polygon fill="#15120C" points="912.292,490.686 905.136,540.031 815.998,545.598 816.118,493.401 	"/>
							<polygon fill="#15120C" points="746.674,453.552 744.16,512.37 647.639,489.496 645.879,435.957 	"/>
							<polygon fill="#050402" points="746.674,453.552 767.537,386.691 763.766,437.716 744.16,512.37 	"/>
							<g>
								<polygon fill="#262015" points="767.537,386.691 772.187,346.096 688.296,337.048 684.086,376.385 		"/>
								<polygon fill="#262015" points="684.086,376.385 645.879,435.957 604.971,412.832 649.713,354.517 		"/>
								<polygon fill="#262015" points="767.537,386.691 746.674,453.552 759.493,444 778.848,375.128 		"/>
								<polygon fill="#262015" points="746.674,453.552 645.879,435.957 626.273,436.962 742.401,458.328 		"/>
								<polygon fill="#050402" points="767.537,386.691 751.862,436.927 689.804,425.086 684.086,376.385 		"/>
								<polygon fill="#15120C" points="684.086,376.385 689.804,425.086 680.411,441.984 645.879,435.957 		"/>
								<polygon fill="#36260D" points="689.804,425.086 751.862,436.927 746.674,453.552 680.411,441.984 		"/>
							</g>
							<polygon fill="#15120C" points="994.126,636.815 991.612,695.633 895.091,672.759 893.331,619.22 	"/>
							<polygon fill="#050402" points="994.126,636.815 1014.988,569.954 1011.218,620.979 991.612,695.633 	"/>
							<g>
								<polygon fill="#262015" points="1014.988,569.954 1019.638,529.359 935.748,520.311 931.537,559.648 		"/>
								<polygon fill="#262015" points="931.537,559.648 893.331,619.22 852.423,596.095 897.164,537.78 		"/>
								<polygon fill="#262015" points="1014.988,569.954 994.126,636.815 1006.945,627.263 1026.299,558.391 		"/>
								<polygon fill="#262015" points="994.126,636.815 893.331,619.22 873.725,620.225 989.852,641.591 		"/>
								<polygon fill="#050402" points="1014.988,569.954 999.314,620.19 937.256,608.349 931.537,559.648 		"/>
								<polygon fill="#15120C" points="931.537,559.648 937.256,608.349 927.863,625.247 893.331,619.22 		"/>
								<polygon fill="#36260D" points="937.256,608.349 999.314,620.19 994.126,636.815 927.863,625.247 		"/>
							</g>
							<polygon fill="#050402" points="350.846,468.29 352.726,522.343 402.117,457.86 403.827,412.605 	"/>
							<polygon fill="#15120C" points="350.846,468.29 278.252,434.022 286.871,482.83 352.726,522.343 	"/>
							<g>
								<polygon fill="#262015" points="403.827,412.605 340.25,388.933 360.604,345.342 425.532,367.492 		"/>
								<polygon fill="#262015" points="340.25,388.933 278.252,434.022 249.846,397.556 315.62,357.314 		"/>
								<polygon fill="#262015" points="403.827,412.605 350.846,468.29 370.009,458.821 415.775,408.096 		"/>
								<path fill="#262015" d="M350.846,468.29c-0.902,0-72.594-34.268-72.594-34.268l-36.748-8.792l89.503,44.188L350.846,468.29z"/>
								<polygon fill="#15120C" points="340.25,388.933 344.365,439.151 326.22,456.842 278.252,434.022 		"/>
								<polygon fill="#050402" points="344.365,439.151 368.832,449.385 403.827,412.605 340.25,388.933 		"/>
								<polygon fill="#36260D" points="344.365,439.151 326.22,456.842 350.846,468.29 368.832,449.385 		"/>
							</g>
							<polygon fill="#050402" points="638.3,502.71 640.179,556.763 689.571,492.28 691.28,447.025 	"/>
							<polygon fill="#15120C" points="638.3,502.71 565.706,468.442 574.325,517.25 640.179,556.763 	"/>
							<g>
								<polygon fill="#262015" points="691.28,447.025 627.704,423.353 648.057,379.762 712.986,401.912 		"/>
								<polygon fill="#262015" points="627.704,423.353 565.706,468.442 537.299,431.976 603.074,391.734 		"/>
								<polygon fill="#262015" points="691.28,447.025 638.3,502.71 657.463,493.241 703.229,442.516 		"/>
								<path fill="#262015" d="M638.3,502.71c-0.902,0-72.594-34.268-72.594-34.268l-36.748-8.792l89.503,44.188L638.3,502.71z"/>
								<polygon fill="#15120C" points="627.704,423.353 631.818,473.571 613.673,491.262 565.706,468.442 		"/>
								<polygon fill="#050402" points="631.818,473.571 656.285,483.805 691.28,447.025 627.704,423.353 		"/>
								<polygon fill="#36260D" points="631.818,473.571 613.673,491.262 638.3,502.71 656.285,483.805 		"/>
							</g>
							<polygon fill="#050402" points="765.281,534.107 767.161,588.159 816.552,523.676 818.262,478.421 	"/>
							<polygon fill="#15120C" points="765.281,534.107 692.687,499.839 701.306,548.646 767.161,588.159 	"/>
							<g>
								<polygon fill="#262015" points="818.262,478.421 754.685,454.749 775.039,411.158 839.967,433.309 		"/>
								<polygon fill="#262015" points="754.685,454.749 692.687,499.839 664.281,463.373 730.055,423.13 		"/>
								<polygon fill="#262015" points="818.262,478.421 765.281,534.107 784.445,524.638 830.21,473.912 		"/>
								<path fill="#262015" d="M765.281,534.107c-0.902,0-72.594-34.268-72.594-34.268l-36.748-8.792l89.503,44.188L765.281,534.107z"/>
								<polygon fill="#15120C" points="754.685,454.749 758.8,504.968 740.655,522.658 692.687,499.839 		"/>
								<polygon fill="#050402" points="758.8,504.968 783.267,515.201 818.262,478.421 754.685,454.749 		"/>
								<polygon fill="#36260D" points="758.8,504.968 740.655,522.658 765.281,534.107 783.267,515.201 		"/>
							</g>
							<polygon fill="#050402" points="1056.068,574.11 1057.948,628.162 1107.339,563.679 1109.048,518.425 	"/>
							<polygon fill="#15120C" points="1056.068,574.11 983.474,539.842 992.093,588.649 1057.948,628.162 	"/>
							<g>
								<polygon fill="#262015" points="1109.048,518.425 1045.472,494.753 1065.825,451.162 1130.754,473.312 		"/>
								<polygon fill="#262015" points="1045.472,494.753 983.474,539.842 955.068,503.376 1020.842,463.134 		"/>
								<polygon fill="#262015" points="1109.048,518.425 1056.068,574.11 1075.231,564.641 1120.997,513.916 		"/>
								<path fill="#262015" d="M1056.068,574.11c-0.902,0-72.594-34.268-72.594-34.268l-36.748-8.792l89.503,44.188L1056.068,574.11z"/>
								<polygon fill="#15120C" points="1045.472,494.753 1049.587,544.971 1031.442,562.662 983.474,539.842 		"/>
								<polygon fill="#050402" points="1049.587,544.971 1074.054,555.204 1109.048,518.425 1045.472,494.753 		"/>
								<polygon fill="#36260D" points="1049.587,544.971 1031.442,562.662 1056.068,574.11 1074.054,555.204 		"/>
							</g>
							<polygon fill="#262015" points="209.939,394.403 113.765,397.118 110.839,349.034 207.563,348.017 	"/>
							<polygon fill="#262015" points="209.939,394.403 227.671,440.698 237.109,424.988 213.28,374.538 	"/>
							<polygon fill="#262015" points="113.765,397.118 73.457,409.821 72.659,464.504 113.644,449.315 	"/>
							<polygon fill="#262015" points="113.644,449.315 227.671,440.698 237.291,497.873 110.793,512.402 	"/>
							<polygon fill="#050402" points="227.671,440.698 202.782,443.749 209.939,394.403 	"/>
							<polygon fill="#15120C" points="209.939,394.403 202.782,443.749 113.644,449.315 113.765,397.118 	"/>
							<g>
								<polygon fill="#15120C" points="435.964,564.254 433.45,623.072 336.929,600.198 335.169,546.659 		"/>
								<polygon fill="#050402" points="435.964,564.254 456.827,497.393 453.056,548.418 433.45,623.072 		"/>
								<g>
									<polygon fill="#262015" points="456.827,497.393 461.477,456.798 377.586,447.75 373.376,487.087 			"/>
									<polygon fill="#262015" points="373.376,487.087 335.169,546.659 294.261,523.534 339.003,465.219 			"/>
									<polygon fill="#262015" points="456.827,497.393 435.964,564.254 448.783,554.702 468.138,485.83 			"/>
									<polygon fill="#262015" points="435.964,564.254 335.169,546.659 315.563,547.664 431.691,569.03 			"/>
									<polygon fill="#050402" points="456.827,497.393 441.152,547.629 379.094,535.788 373.376,487.087 			"/>
									<polygon fill="#15120C" points="373.376,487.087 379.094,535.788 369.702,552.686 335.169,546.659 			"/>
									<polygon fill="#36260D" points="379.094,535.788 441.152,547.629 435.964,564.254 369.702,552.686 			"/>
								</g>
							</g>
						</g>
						<g id="front">
							<polygon fill="#383122" points="712.282,748.881 715.692,828.673 846.632,797.643 849.019,725.012 	"/>
							<polygon fill="#282114" points="712.282,748.881 683.98,658.178 689.094,727.399 715.692,828.673 	"/>
							<g>
								<polygon fill="#494232" points="683.98,658.178 677.671,603.108 791.477,590.833 797.188,644.198 		"/>
								<polygon fill="#494232" points="797.188,644.198 849.019,725.012 904.515,693.641 843.819,614.531 		"/>
								<polygon fill="#494232" points="683.98,658.178 712.282,748.881 694.891,735.924 668.635,642.493 		"/>
								<polygon fill="#494232" points="712.282,748.881 849.019,725.012 875.616,726.376 718.079,755.36 		"/>
								<polygon fill="#282114" points="683.98,658.178 705.244,726.328 789.431,710.264 797.188,644.198 		"/>
								<polygon fill="#383122" points="797.188,644.198 789.431,710.264 802.173,733.188 849.019,725.012 		"/>
								<polygon fill="#594421" points="789.431,710.264 705.244,726.328 712.282,748.881 802.173,733.188 		"/>
							</g>
							<polygon fill="#494232" points="174.726,670.864 289.173,697.332 303.339,631.348 187.773,607.117 	"/>
							<polygon fill="#494232" points="174.726,670.864 140.429,731.256 119.18,685.776 162.796,620.91 	"/>
							<polygon fill="#494232" points="289.173,697.332 307.812,656.325 290.664,758.097 278.362,769.654 	"/>
							<polygon fill="#494232" points="278.362,769.654 140.429,731.256 115.079,808.424 269.042,857.632 	"/>
							<polygon fill="#282114" points="140.429,731.256 174.26,740.716 174.726,670.864 	"/>
							<polygon fill="#383122" points="174.726,670.864 174.26,740.716 278.362,769.654 289.173,697.332 	"/>
							<polygon fill="#494232" points="618.865,627.447 484.132,631.251 480.032,563.888 615.536,562.464 	"/>
							<polygon fill="#494232" points="618.865,627.447 643.707,692.304 656.929,670.296 623.545,599.617 	"/>
							<polygon fill="#494232" points="484.132,631.251 427.663,649.047 426.545,725.655 483.962,704.375 	"/>
							<polygon fill="#494232" points="483.962,704.375 643.707,692.304 657.184,772.403 479.968,792.756 	"/>
							<polygon fill="#282114" points="643.707,692.304 608.839,696.577 618.865,627.447 	"/>
							<polygon fill="#383122" points="618.865,627.447 608.839,696.577 483.962,704.375 484.132,631.251 	"/>
							<polygon fill="#282114" points="33.767,784.746 36.401,860.47 105.595,770.133 107.989,706.734 	"/>
							<polygon fill="#383122" points="33.767,784.746 -67.932,736.738 -55.858,805.114 36.401,860.47 	"/>
							<g>
								<polygon fill="#494232" points="107.989,706.734 18.923,673.571 47.437,612.503 138.398,643.534 		"/>
								<polygon fill="#494232" points="18.923,673.571 -67.932,736.738 -107.728,685.652 -15.582,629.275 		"/>
								<polygon fill="#494232" points="107.989,706.734 33.767,784.746 60.614,771.481 124.729,700.417 		"/>
								<path fill="#494232" d="M33.767,784.746c-1.263,0-101.7-48.007-101.7-48.007l-51.482-12.318L5.974,786.325L33.767,784.746z"/>
								<polygon fill="#383122" points="18.923,673.571 24.687,743.924 -0.733,768.707 -67.932,736.738 		"/>
								<polygon fill="#282114" points="24.687,743.924 58.964,758.26 107.989,706.734 18.923,673.571 		"/>
								<polygon fill="#594421" points="24.687,743.924 -0.733,768.707 33.767,784.746 58.964,758.26 		"/>
							</g>
							<polygon fill="#494232" points="697.971,609.134 825.708,638.676 841.519,565.029 712.534,537.984 	"/>
							<polygon fill="#494232" points="697.971,609.134 659.692,676.539 635.975,625.777 684.657,553.379 	"/>
							<polygon fill="#494232" points="825.708,638.676 846.512,592.907 827.373,706.497 813.642,719.396 	"/>
							<polygon fill="#494232" points="813.642,719.396 659.692,676.539 631.398,762.668 803.24,817.591 	"/>
							<polygon fill="#282114" points="659.692,676.539 697.451,687.097 697.971,609.134 	"/>
							<polygon fill="#383122" points="697.971,609.134 697.451,687.097 813.642,719.396 825.708,638.676 	"/>
							<polygon fill="#383122" points="440.277,836.726 436.756,919.126 301.535,887.082 299.07,812.077 	"/>
							<polygon fill="#282114" points="440.277,836.726 469.505,743.058 464.223,814.542 436.756,919.126 	"/>
							<g>
								<polygon fill="#494232" points="469.505,743.058 476.019,686.188 358.494,673.511 352.595,728.62 		"/>
								<polygon fill="#494232" points="352.595,728.62 299.07,812.077 241.76,779.68 304.441,697.984 		"/>
								<polygon fill="#494232" points="469.505,743.058 440.277,836.726 458.236,823.345 485.351,726.86 		"/>
								<polygon fill="#494232" points="440.277,836.726 299.07,812.077 271.604,813.485 434.291,843.417 		"/>
								<polygon fill="#282114" points="469.505,743.058 447.546,813.436 360.606,796.847 352.595,728.62 		"/>
								<polygon fill="#383122" points="352.595,728.62 360.606,796.847 347.448,820.52 299.07,812.077 		"/>
								<polygon fill="#594421" points="360.606,796.847 447.546,813.436 440.277,836.726 347.448,820.52 		"/>
							</g>
							<polygon fill="#383122" points="1026.287,746.416 1022.766,828.816 887.545,796.772 885.08,721.767 	"/>
							<polygon fill="#282114" points="1026.287,746.416 1055.514,652.748 1050.232,724.231 1022.766,828.816 	"/>
							<g>
								<polygon fill="#494232" points="1055.514,652.748 1062.029,595.878 944.503,583.201 938.605,638.31 		"/>
								<polygon fill="#494232" points="938.605,638.31 885.08,721.766 827.77,689.37 890.45,607.674 		"/>
								<polygon fill="#494232" points="1055.514,652.748 1026.287,746.416 1044.246,733.035 1071.361,636.549 		"/>
								<polygon fill="#494232" points="1026.287,746.416 885.08,721.766 857.614,723.175 1020.301,753.107 		"/>
								<polygon fill="#282114" points="1055.514,652.748 1033.555,723.126 946.616,706.537 938.605,638.31 		"/>
								<polygon fill="#383122" points="938.605,638.31 946.616,706.537 933.458,730.209 885.08,721.767 		"/>
								<polygon fill="#594421" points="946.616,706.537 1033.555,723.126 1026.287,746.416 933.458,730.209 		"/>
							</g>
							<g>
								<polygon fill="#383122" points="400.489,717.376 395.785,827.448 215.155,784.642 211.862,684.449 		"/>
								<polygon fill="#282114" points="400.489,717.376 439.531,592.252 432.476,687.742 395.785,827.448 		"/>
								<g>
									<polygon fill="#494232" points="439.531,592.252 448.234,516.284 291.241,499.35 283.361,572.966 			"/>
									<polygon fill="#494232" points="283.361,572.966 211.862,684.449 135.306,641.173 219.035,532.042 			"/>
									<polygon fill="#494232" points="439.531,592.252 400.489,717.376 424.479,699.502 460.699,570.614 			"/>
									<polygon fill="#494232" points="400.489,717.376 211.862,684.449 175.171,686.331 392.492,726.314 			"/>
									<polygon fill="#282114" points="439.531,592.252 410.198,686.265 294.063,664.105 283.362,572.966 			"/>
									<polygon fill="#383122" points="283.362,572.966 294.063,664.105 276.485,695.727 211.862,684.449 			"/>
									<polygon fill="#594421" points="294.063,664.105 410.198,686.265 400.489,717.376 276.485,695.727 			"/>
								</g>
							</g>
						</g>
						<path id="lightning4" ref="lightning4" fill="#FF5910" d="M745.8,309.5L751,299l15.6,0.6l12.2-11l14.4,8.7l-10,67.9l21.4,36.7l6.9,25.1l-4.5-25.8	l-21-36.7l10.1-68.8l-16.5-10l0.4-12.1l25.6-19.7l2-0.6l7.5,18.7l-3.9,50l17.4,25l-15.4-25.3l4.3-49.8l-6-19.9l24.2-7.4l19.2,37.9	l-13.2,22.8c0,0,2.2,8,2.4,7.1c0.1-0.9,0-6.8,0-6.8l13.5-20.5l35.6,23.3l7.1,34.7l-13.7,23.1l-7.3,37.6l7.3,26.3L879,442l9.8-11.8	l-7.2-26.5l4-20.3l24.4,32l4.3,38.8l-2.2-40.1l-25.6-33.8l2.7-13.2l14.5-23.6l-8.2-37.7l-36.7-23.4l-19.2-39.3l31.4-29.8l32.9,36.6	l38.9,3.2l27.2,31l-4.4,24.9l6.8-26l-28.7-32.6l-38.3-2.9L874,210.9l2.1-2.7l-10.8-36.6l21.3-16.1l3.5-23.4l20.4-13.3l-6.8-56.5	L857,0h-9.1l51.3,64.3l6.5,52.7l-47.2,30.4l1.6,21.9l-16.8,4.4l-17.1,23.2l19.1-20.3l15.5-3.7l11.2,34.6l-35.3,34.1l-31.7,9	L776.6,272l-0.2,14.8l-11.2,10.3l-15.7,0.5L745.8,309.5z M864.2,168.2l-0.9-18.7l23.7-15.4l-2.8,20.6L864.2,168.2z"/>
						<path id="lightning3" ref="lightning3" fill="#FF5910" d="M122.8,389.4l-6.2-30.8l31.7-41.8l48.5-5.9l39.6-48.7l41.8,36.4l-20.6,49.7L230,369.7	l1.9,39.5l2.7-1.2l-1.7-36.8l25.5-19.7l17.1,25.9c0,0,0.2,7.5,0.4,8.6c0.2,1.1,2.5-9.1,2.5-9.1l-18.1-28L282,300l39.5,8.9l9,34	l-30.4,20.7l1.8,13.2l2.7-1.2l-1.2-10.8l30.7-20.8l-9.9-37.4l-42.6-10.1L233.7,255l8.3-44l23.7,3.6l25.4,24.4l-23-28.2l-25.4-4.4	L247,180l-33.3-22.8l3-14.1l-51.4-41.9L167,0h-5.8l-1,79.2c-6.6,7.4-28.6,32.3-28.3,32.8c0.4,0.7,9.9,33.1,9.9,33.1l0.4,19	l13.6,13.4L145,163.4l-0.4-16.5l45.2,9l7.5,24l12.1,14.6l25.1,27l-5.4,34.2l4.9,4.2l-39,47.7l-48.4,6.7l-32.7,43.5L122.8,389.4z	 M201.7,181.5l36.3,19.1l-2.9,17.2l-24.2-25L201.7,181.5z M238.7,196.9L200,177.6l-7.8-24.2l-47.7-10.6l-9.8-31.3l25.5-27.8	l-0.3,19.5l51.2,41.5L208,158l33.3,23.5L238.7,196.9z"/>
						<path id="lightning2" ref="lightning2" fill="#FFA227" d="M283.7,414.9L290,395l-28.3-41.3l-38.4-26.2l-31.9-61.4l30.5-41.3l19.1,11.8l16.4,35.7	l-12.5-38.7l-20.5-13.4l11.9-28.5l-49.6-61.8L219,62.3l97.3-63l-14.8,0.3l-87.8,58l-34.4,72.5l21.4,26.9l-5.8,32.9l21.3,31.1	l-30.7,44l1.6,4.5L129,304.8l-52.5-13.2l-52.9,30.7L21,360.2l5.2-35.3l50.2-29.2l53.5,13.1l60.4-34.3l28.6,53.9l-43.2,44l-59.6,14.9	L88.3,434l8.8,38l-2.3,18.9l-49.4,33.7l-20.9,52.6l23.1-50l47-31.9l-3.7,29l-21.6,32.2l7.8,20.2l-4.8-19.3l21.6-31.9l7-53.5l-8-37	l25-43.2l58.1-15.2l8.9,33.4c0,0-2.8,7.9-3.1,9.1c-0.2,1.2,6.3-8.4,6.3-8.4l-7.4-36.5l42.6-42l29,20.7l-16.9,23.9l-16.6,68.5	l-32,26.7l34.5-25.6l17.2-68.6l18.4-21.7l2.4,1.7l25.4,37.7l-4.9,16.4l-26.5,6l-15.9,88.8c1-0.8,2-1.6,3-2.4	c0.5-0.4,1.1-0.8,1.6-1.1l14.6-81.9l23.1-5.1l11.3,20.2l21.1,6.2l2.2,16.3l0.4-17.6l-20.8-7.6L283.7,414.9z M198.7,190l5.4-28.8	l24.8,31.2l-9.6,24.5L198.7,190z"/>
						<path id="lightning1" ref="lightning1" fill="#FFA227" d="M1015,411.4l-66.8-35.8l-65.1,19.9L806,358.2l3.7-8.2l-26.8-40l15.9-48.7l6.7-25.6	l-4.5-34.6l51.8-37.8l9.1,21l-5.3,24.1l9.4-24.8l-10.6-24.2c0,0-6.9-46.4-6.9-47.5c0.1-0.9-42.3-19.4-54.9-24.9L751.3,0l-8.6-0.4	l57.2,118l-40.3,83l12,16L743,264.8l20.9,30.8L734.4,316l-12.6,49.1l17.7-45.7l27.9-18.4l36.2,50.7l-36.2,80.5l-47.8,37.7l5.5,31.5	c1.6-0.3,3.3-0.2,4.6,0.5l-5.4-30.7l44.6-34.4l56.1,49.1l-6.5,45.9c0,0,8.9,11.5,8.5,10s-4.5-11.1-4.5-11.1l6.4-42.7l43.8,10	l0.3,0.8c1.4-0.4,2.7-0.6,4.1-0.4l-1.6-3.9l-47.4-10.9L773,433.1l31.5-70.5l78.5,38.3l64.6-20.9l64.5,34.2l10.2,42.6L1015,411.4z	 M763.4,281.5l-12.1-17.8l28.3-49.1l-11.8-15l40.3-82.4l-11.9-24.5l48.5,20.1l5.9,45.3l-54,41.3l4.3,35.1L763.4,281.5z M766.4,285.9	l34.7-45.5l-5.1,19.8L780.1,306L766.4,285.9z"/>
					</svg>
				</div>
				<div className="rc-logo" ref="container">

					<svg version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 1024 768" enableBackground="new 0 0 1024 768" preserveAspectRatio="xMidYMid">
						<g id="flames" ref="flames">
							<path fill="#E70728" d="M740.634,58.166c4.765,29.172-12.546,52.694-73.058,53.185c-60.512,0.491-87.273,52.905-91.797,99.46
								c-4.524,46.554-43.567,72.721-88.961,63.46c-45.391-9.161-46.673-42.337-42.368-65.875c4.208-23.435,50.412-54.415,49.107-98.496
								s-40.669-52.419-40.669-52.419s22.226,17.45,16.718,40.923s-34.239,43.132-86.486,45.679s-89.251,40.158-81.94,97.867
								s-0.198,71.037-14.224,73.753c-14.026,2.716-29.153-18.245-16.012-50.848c-63.357,5.777-52.149,103.888-101.265,90.536
								c-18.155-4.965-25.516-50.867-0.656-66.109s69.094-45.164,29.256-99.909c3.222,31.118-16.447,56.111-59.179,69.181
								s-68.236,40.337-67.491,65.526c1.867,63.072,73.743,67.948,72.177,136.724c-1.563,65.475-57.215,101.737-18.44,178.023
								s148.253,90.853,261.555,35.176c113.302-55.677,219.06-51.905,312.198-21.547c93.136,30.257,191.007,71.779,230.917,0.567
								c29.554-52.697-23.425-91.747-19.924-139.071c3.504-47.224,51.365-66.149,51.365-66.149c-63.102,0.868-84.753,40.025-91.311,58.427
								c-17.263,48.832,22.102,104.492-33.793,98.743c-52.181-5.358-52.994-59.858-45.669-92.889
								c20.908-94.66,150.822-113.012,153.423-177.217c2.335-59.695-41.878-72.993-41.878-72.993s10.768,12.287,11.65,42.074
								c0.731,24.689-18.531,39.766-40.722,40.423c-17.792,0.527-36.692-12.72-37.379-35.91c-0.876-29.587,24.469-31.838,22.744-73.205
								s-44.293-63.317-44.509-87.521s24.239-32.832,24.239-32.832s-38.217-6.772-48.122,23.634c-10.187,31.015,7.387,56.906,1.185,80.6
								c-4.23,15.932-17.971,35.047-45.668,32.165c-27.095-2.799-44.236-27.603-38.691-56.58c11.513-60.567,61.309-61.441,60.211-98.525
								C766.125,67.615,740.634,58.166,740.634,58.166z"/>
							<path fill="#FF5910" d="M506.25,137.114c-34.391,35.939-71.998-2.262-104.947,23.346s-9.713,93.578-38.8,92.475
								c-20.492-0.77-38.115-18.696-29.247-50.207c0,0-25.724,15.737-16.922,57.963c5.77,28.111,31.177,27.183,26.898,55.772
								c-4.285,28.69-29.646,19.201-38.39,61.641c-7.045,34.43,15.101,39.21,11.646,67.45c-3.437,27.941-26.298,41.15-47.334,37.842
								c-21.036-3.308-33.942-18.136-31.957-42.059c1.979-23.823,24.503-25.131,29.412-67.108c4.809-41.983-30.59-52.795-30.59-52.795
								s12.191,18.29,5.396,40.612s-63.846,37.519-71.983,84.705c-8.137,47.187,10.012,69.553,35.614,86.471s44.342,21.687,47.201,40.2
								c3.122,20.733-13.901,33.503-9.126,55.04c6.757,29.976,57.803,48.572,106.012,27.317c48.209-21.256,156.344-70.154,308.17-20.658
								c72.182,23.515,90.29-18.044,94.044-34.944c10.576-47.737-28.244-79.301-13.711-110.06c22.472-47.299,86.98-13.139,103.646-57.292
								c11.258-29.66-14.496-53.801-6.861-79.978c7.536-26.184,27.568-34.158,32.192-57.016c4.63-22.957-3.866-37.812-13.687-42.629
								c0,0,6.604,24.356-2.048,36.243c-8.646,11.787-35.867-0.021-51.492,28.967c-15.619,28.888-7.397,43.325-14.347,55.218
								c-6.95,11.892-31.105,34.64-53.079,23.859c-22.074-10.788-24.444-35.582-11.628-54.825c13.926-20.978,16.843-51.857,3.366-86.558
								c-13.377-34.695-21.142-58.121-14.567-72.04s17.148-26.088,35.069-27.481c0,0-45.281-14.632-67.515,20.759
								s-20.198,67.178-25.4,83.187s-33.229,54.347-61.378,44.585c-22.46-7.806-30.009-37.931-22.716-63.428
								c6.651-23.233,28.817-30.073,28.817-30.073c-84.602-10.659-87.926,59.069-74.48,81.344c12.073,20.186,21.645,53.242,0.402,61.343
								c-16.933,6.464-33.279-1.363-29.83-29.504c3.455-28.24-6.531-41.684-29.955-43.639c-23.324-1.948-46.014-22.192-43.761-47.2
								c2.271-25.308,18.721-36.912,46.794-45.289C502.233,177.642,506.25,137.114,506.25,137.114z"/>
							<path fill="#FFA127" d="M661.354,269.816c-17.615,6.657-16.196,22.208-11.367,37.465s-5.587,31.742-37.645,36.35
								s-62.005,5.68-71.846,35.89c-9.844,30.309,14.858,40.28,11.382,68.485c-3.476,28.206-18.294,38.251-34.118,38.761
								c-15.823,0.51-31.599-10.184-31.226-31.883s15.683-37.932,4.586-63.988c-13.607-32.237-41.14-31.59-52.192-36.535
								s-17.611-16.053-15.924-28.507c-14.023,16.673-12.001,35.345-5.765,43.942c7.574,10.64,20.656,56.567-31.561,46.644
								c-31.133-5.868-41.519-35.504-20.583-52.463c14.674-11.851,32.325-26.11,34.228-48.762c2.844-33.628-31.917-32.205-31.04-50.786
								c0.597-12.788,11.316-13.255,11.316-13.255s-22.452-1.897-22.99,18.696c-0.421,16.795,20.872,17.355,16.362,33.723
								c-7.218,26.289-71.41,5.689-85.57,52.572c-27.212,90.299,90.413,75.138,80.722,132.765c-3.428,20.203-17.821,32.663-42.378,30.901
								c-24.657-1.765-67.683-17.707-49.372-40.35c29.442-36.404-21.65-59.999-7.378-81.467c-25.295,9.12-1.243,40.08-16.621,48.808
								s-29.299,22.102-25.624,42.326c3.675,20.223-7.334,26.785-17.13,23.28c-9.793-3.605-12.618-22.202,0.379-34.805
								c13.1-12.7,13.218-29.404,2.24-39.949c3.188,23.01-31.862,14.419-39.213,35.301c-14.155,40.28,34.704,48.799,23.33,96.169
								c-20.67,85.8,95.801,72.404,151.558,35.915c55.754-36.389,135.944-44.507,205.915-19.926s138.26,55.012,154.903,21.612
								c13.546-27.093-5.099-48.481-9.502-54.92c-4.406-6.34-11.481-23.367-0.066-39.821c11.416-16.454,11.246-33.567-6.717-47.931
								s-21.574-26.982-8.014-38.367c0,0-24.248-2.053-29.537,20.094c-5.292,22.246,12.721,25.306,8.54,43.986
								c-5.326,23.346-38.219,25.827-52.605,12.275c-14.384-13.652-25.514-48.314,4.598-77.294c30.213-28.977,73.408-37.842,72.923-80.277
								C687.733,299.948,642.355,298.54,661.354,269.816z"/>
							<path fill="#FF5910" d="M295.675,79.881c-76.874,24.25-11.725,75.351-42.271,112.062
								C330.324,161.293,254.391,113.746,295.675,79.881z"/>
							<path fill="#FF5910" d="M946.145,142.92c45.32,66.683-37.582,66.38-36.253,114.174C868.548,185.392,957.495,195.066,946.145,142.92
								z"/>
							<path fill="#E70728" d="M599.042,38.844c15.15,57.402-73.738,40.043-48.235,99.408c0.358-21.998,42.169-21.938,62.312-39.133
								C633.159,82.022,623.733,43.471,599.042,38.844z"/>
							<path fill="#E70728" d="M167.895,195.963c4.171-44.234-19.31-39.742-33.395-46.488c-14.184-6.748-21.408-22.676-9.881-41.378
								c-26.903,11.433-22.941,48.107-15.978,56.03C124.334,181.902,147.282,156.398,167.895,195.963z"/>
							<path fill="#E70728" d="M1001.274,340.143c-35.422,26.898-16.238,41.065-11.633,56.12c4.602,14.955-2.263,31.093-23.734,35.312
								c29.991,8.203,47.343-5.484,45.006-24.516C1007.973,381.942,984.955,366.803,1001.274,340.143z"/>
							<path fill="#FFA127" d="M737.713,325.591c21.493,43.703-61.707,48.09-27.116,108.995c-2.996-27.6,22.904-24.996,40.005-39.194
								C773.905,375.896,771.51,340.896,737.713,325.591z"/>
							<path fill="#FFA127" d="M168.743,366.31c-7.586,20.105,12.312,18.391,10.924,35.792c-1.488,17.401-15.787,19.611,2.028,41.398
								c0,0-4.41-14.797,12.186-20.108s19.582-26.313,7.374-38.105C188.948,373.496,170.255,383.209,168.743,366.31z"/>
							<path fill="#FFA127" d="M719.698,542.122c-13.391-24.951,1.132-46.004,25.906-53.195c18.88-5.469,37.946-14.739,38.179-33.139
								c20.009,29.827,0.091,52.3-23.294,56.485C735.804,516.563,718.326,522.426,719.698,542.122z"/>
						</g>
						<g id="triangle" ref="triangle" transform="matrix(1,0,0,1,0,0)">
							<g>
								<polygon fill="#822193" points="831.7,369.2 831.7,388.9 512,684.1 512,664.3 		"/>
								<polygon fill="#351138" points="831.7,369.2 512,664.3 192.3,369.2 512,369.2 		"/>
								<polygon fill="#640F6D" points="512,664.3 512,684.1 192.3,388.9 192.3,369.2 		"/>
							</g>
						</g>
						<g id="click" ref="click" transform="matrix(1,0,0,1,0,0)">
							<path fill="#19A1F4" d="M688.5,582.646v-31.692v-23.379v0v-4.396c0-12.988-10.6-23.579-23.6-23.679H361.8
								c-13,0-23.7,10.69-23.7,23.679v4.396H338v30.173c0.033-0.013,0.067-0.025,0.1-0.038v10.12v9.9v9.891
								c0,12.988,10.7,23.679,23.7,23.679h303c13,0,23.7-10.69,23.7-23.679l0.1-4.951L688.5,582.646z"/>
							<g>
								<path fill="#008DD3" d="M688.5,550.954v32.971h-0.2c-132.9,42.662-240.5-50.455-350.2-6.194l0,0v-20.082
									c77.8-31.572,257.8,38.965,350.3-6.794L688.5,550.954L688.5,550.954z"/>
								<path fill="#19A1F4" d="M688.5,527.575v23.379h-0.2c-92.4,45.759-272.5-24.778-350.3,6.794v-30.173h3.6
									c0,0,6.1-18.384,26.2-18.384h290.8c19.9,0,26.2,18.384,26.2,18.384H688.5L688.5,527.575z"/>
								<path fill="#0083B7" d="M688.5,587.621c0,12.988-10.7,23.679-23.7,23.679h-303c-13,0-23.7-10.69-23.7-23.679v-9.791l0,0
									c109.7-44.36,217.3,48.756,350.2,6.195h0.2V587.621z"/>
								<path fill="#85DDFF" d="M661.7,504.396c12.8,0,23.2,10.391,23.2,23.179c0,0-6.3-18.384-26.2-18.384H367.9
									c-20.2,0-26.2,18.384-26.2,18.384c0-12.689,10.4-23.179,23.2-23.179L661.7,504.396L661.7,504.396z"/>
								<path fill="#19A1F4" d="M688.5,523.179v4.396h-3.6c0-12.689-10.4-23.179-23.2-23.179H364.9c-12.7,0-23.2,10.391-23.2,23.179h-3.6
									v-4.396c0-12.988,10.7-23.679,23.7-23.679h303.1C677.9,499.6,688.5,510.19,688.5,523.179z"/>
							</g>
							<g id="GlintGroup">
								<g>
									<g>
										<g>
											<g>
												<defs>
													<path id="SVGID_1_" d="M664.9,499.6H361.8c-13,0-23.7,10.69-23.7,23.679v4.396l0,0v30.173v20.082l0,0v9.791
														c0,12.988,10.7,23.679,23.7,23.679h303.1c13,0,23.7-10.69,23.7-23.679v-3.597l0,0v-32.971v-23.379v-4.396
														C688.5,510.19,677.9,499.6,664.9,499.6z"/>
												</defs>
												<clipPath id="SVGID_2_">
													<use href="#SVGID_1_"  overflow="visible"/>
												</clipPath>
												<polygon id="glint3" ref="glint3" clipPath="url(#SVGID_2_)" fill="#FFFFFF"  points="432.4,463.532
													379.5,463.532 339.5,639.375 392.4,639.375 						"/>
											</g>
										</g>
									</g>
									<g>
										<g>
											<g>
												<defs>
													<path id="SVGID_3_" d="M664.9,499.6H361.8c-13,0-23.7,10.69-23.7,23.679v4.396l0,0v30.173v20.082l0,0v9.791
														c0,12.988,10.7,23.679,23.7,23.679h303.1c13,0,23.7-10.69,23.7-23.679v-3.597l0,0v-32.971v-23.379v-4.396
														C688.5,510.19,677.9,499.6,664.9,499.6z M684,525.477"/>
												</defs>
												<clipPath id="SVGID_4_">
													<use href="#SVGID_3_"  overflow="visible"/>
												</clipPath>
												<polygon id="glint2"  ref="glint2" clipPath="url(#SVGID_4_)" fill="#FFFFFF"  points="432.4,463.532
													379.5,463.532 339.5,639.375 392.4,639.375 						"/>
											</g>
										</g>
									</g>
									<g>
										<g>
											<g>
												<defs>
													<path id="SVGID_5_" d="M664.9,499.6H361.8c-13,0-23.7,10.69-23.7,23.679v4.396l0,0v30.173v20.082l0,0v9.791
														c0,12.988,10.7,23.679,23.7,23.679h303.1c13,0,23.7-10.69,23.7-23.679v-3.597l0,0v-32.971v-23.379v-4.396
														C688.5,510.19,677.9,499.6,664.9,499.6z M684,525.477"/>
												</defs>
												<clipPath id="SVGID_6_">
													<use href="#SVGID_5_"  overflow="visible"/>
												</clipPath>
												<polygon id="glint1"  ref="glint1" clipPath="url(#SVGID_6_)" fill="#FFFFFF"  points="432.4,463.532
													379.5,463.532 339.5,639.375 392.4,639.375 						"/>
											</g>
										</g>
									</g>
								</g>
							</g>
							<g id="TextGroup">
								<path fill="#B6E5FF" d="M448.8,547.657c-2.3-0.3-5.7-1.099-11.6-1.099c-6.1,0-9.8,1.698-9.8,8.093c0,6.594,4.2,7.693,9.7,7.693
									c3.8,0,7.6-0.699,11.7-1.499v13.688c-5.6,1.499-10.9,2.698-16.4,2.698c-16.9,0-23.4-7.793-23.4-24.178
									c0-14.787,6.2-23.079,23-23.079c6.2,0,13.6,2.098,16.7,2.997L448.8,547.657L448.8,547.657z"/>
								<path fill="#B6E5FF" d="M456,531.072h17.4v30.573H491v14.487h-35V531.072z"/>
								<path fill="#B6E5FF" d="M498.2,531.072h17.4v45.06h-17.4L498.2,531.072L498.2,531.072z"/>
								<path fill="#B6E5FF" d="M562.3,547.657c-2.3-0.3-5.7-1.099-11.6-1.099c-6.1,0-9.8,1.698-9.8,8.093c0,6.594,4.2,7.693,9.7,7.693
									c3.8,0,7.6-0.699,11.7-1.499v13.688c-5.6,1.499-10.9,2.698-16.4,2.698c-16.9,0-23.4-7.793-23.4-24.178
									c0-14.787,6.2-23.079,23-23.079c6.2,0,13.6,2.098,16.7,2.997L562.3,547.657L562.3,547.657z"/>
								<path fill="#B6E5FF" d="M569.5,531.072h16.9v17.484h0.2l10-17.484h20.6l-16.6,21.88l17.1,23.179h-21l-10.1-17.684h-0.2v17.684
									h-16.9L569.5,531.072L569.5,531.072z"/>
							</g>
						</g>
						<g id="rage" ref="rage" transform="matrix(1,0,0,1,0,0)">
							<g opacity="0.3">
								<path d="M731.6,369.2L731.6,369.2c-1.2-0.4-2.4-0.7-3.6-1C729.2,368.5,730.4,368.8,731.6,369.2z"/>
								<path d="M805.1,461.9l0.1-0.1c-0.4,0.5-0.8,1-1.3,1.5C804.3,462.9,804.7,462.4,805.1,461.9z"/>
								<path d="M503.1,463.5c-2.4,0-4.8,0-7.3,0.1c-3.2,0.1-6.5,0.1-9.7,0.2c3.2-0.1,6.4-0.2,9.7-0.2
									C498.3,463.5,500.7,463.5,503.1,463.5z"/>
								<path d="M289.4,429.4c0.5,0,1,0.1,1.6,0.2C290.4,429.5,289.8,429.4,289.4,429.4l-10.2,20l0,0L289.4,429.4z"/>
								<path d="M477.9,464.2c-1.5,0.1-3,0.2-4.4,0.2c-1.4,0.1-2.8,0.2-4.1,0.3c1.3-0.1,2.7-0.2,4.1-0.3
									C474.8,464.3,476.4,464.2,477.9,464.2z"/>
								<path d="M457.6,387.3l-5,13.6l6.1-0.2C458.3,395.9,458,391.4,457.6,387.3z"/>
								<path d="M510.8,463.5c-0.2,0-0.3,0-0.5,0c-0.3,0-0.6,0-0.9,0c0.3,0,0.6,0,0.9,0C510.5,463.5,510.7,463.5,510.8,463.5z"/>
								<path d="M736.7,370.9c3.3,1.3,6.4,2.7,9.3,4.2C743.2,373.6,740.1,372.2,736.7,370.9c-1.7-0.6-3.4-1.2-5.1-1.7l0,0
									C733.4,369.7,735.1,370.3,736.7,370.9z"/>
								<polygon points="669.3,421.6 668.4,418.9 662.6,402.6 650.7,369.2 650.7,369.2 		"/>
								<path d="M340.4,369.6c-0.1-0.1-0.2-0.3-0.4-0.4l0,0C340.1,369.3,340.3,369.4,340.4,369.6z"/>
								<path d="M592.6,373.5c0.4,1.6,0.8,3.3,1.1,4.9c0.2,1.3,0.4,2.5,0.6,3.7c-0.2-1.1-0.4-2.4-0.6-3.7
									C593.4,376.8,593,375.1,592.6,373.5s-0.9-3-1.5-4.3l0,0C591.7,370.5,592.2,371.9,592.6,373.5z"/>
								<path d="M302.1,434.3c0.7,0.5,1.3,1.1,1.9,1.7l-0.1-0.1C303.4,435.2,302.8,434.7,302.1,434.3z"/>
								<path d="M513.2,434.6c-0.5-1.3-0.8-2.4-1.1-3.4c0.4,1.5,1,3.5,1.9,5.6c1.2,2.9,2.9,6.3,5.3,9.9c-2.4-3.6-4.1-7-5.2-9.9
									C513.7,436,513.4,435.3,513.2,434.6z"/>
								<path d="M511.2,426.7c0,0.1,0,0.1,0,0.1c0-0.1,0-0.2,0-0.3C511.2,426.6,511.2,426.7,511.2,426.7z"/>
								<path d="M511.3,427.4c0,0.1,0,0.1,0,0.2s0,0.2,0,0.2c0-0.1,0-0.2,0-0.2S511.3,427.5,511.3,427.4z"/>
								<path d="M640.1,475.5l-13.6-11.6c-0.1,0.2-0.6,0.9-1.5,2c1-1.1,1.4-1.9,1.5-2L640.1,475.5z"/>
								<path d="M511.1,424.2v0.1c0-0.1,0-0.2,0-0.2V424.2z"/>
								<path d="M602.8,438.7c0-0.1,0-0.2,0-0.3c-0.1,0.6-0.2,1.1-0.4,1.7C602.6,439.6,602.7,439.2,602.8,438.7z"/>
								<path d="M511.2,425.6L511.2,425.6v-0.1V425.6z"/>
								<path d="M765.2,387.6c-0.5-0.4-1.1-0.9-1.7-1.4c-1.2-0.9-2.6-2-4.3-3.2c1.6,1.2,3.1,2.2,4.2,3.2
									C764.1,386.7,764.6,387.2,765.2,387.6z"/>
								<path d="M597.2,442.5l-17.4-1.5l-11-23.9l2.8-17.1l0,0l18.8,1c0-0.1,0-0.1,0-0.2c-0.2-1.3-0.4-2.8-0.7-4.3s-0.6-3.1-1-4.6
									c-0.9-3.3-2.1-5.9-3.6-8s-3.2-3.6-5.1-4.7s-3.9-1.8-5.8-2.2c-2-0.4-4-0.6-5.8-0.6c-2,0-3.8,0.3-5.6,1c-1.7,0.7-3.3,1.6-4.7,2.9
									c-1.2,1.1-2.2,2.4-3,3.9c0,0,0,0,0,0.1c0.1,3.2,0.3,7,0.5,11c0.1,1.3,0.2,2.6,0.2,3.9c0.2,3.4,0.5,6.9,0.8,10.2
									c0.4,4.6,0.9,9.1,1.4,12.6c0.4,2.3,0.8,5.1,1.7,8.1c0.1,0.5,0.3,1,0.5,1.5c0.8,2.5,2,5.1,3.6,7.5c1.9,2.9,4.5,5.5,8.1,7.4
									s8.1,3.1,13.8,3.3c0.1,0,0.1,0,0.2,0c0.1,0,0.1,0,0.2,0c0.1,0,0.1,0,0.2,0c0.1,0,0.1,0,0.2,0c5.5,0,9.2-1.3,11.7-3.2
									c-0.2-1-0.4-2-0.6-2.7C597.4,443.2,597.3,442.6,597.2,442.5z"/>
								<path d="M583.2,425.2l-4.9-10.7L583.2,425.2z"/>
								<polygon points="689.9,479.7 689.9,479.7 689.5,478.6 		"/>
								<path d="M584.6,477.6L584.6,477.6L584.6,477.6z"/>
								<path d="M602.3,440.7l-0.1,0.2c0,0,0,0,0-0.1C602.3,440.7,602.3,440.7,602.3,440.7z"/>
								<path d="M602.6,430.9c-0.1-0.4-0.1-0.7-0.2-1c0.1,0.4,0.2,0.9,0.3,1.4C602.7,431.1,602.6,431,602.6,430.9z"/>
								<path d="M594.9,387.6c0-0.2-0.1-0.7-0.1-1.4c-0.1-0.5-0.1-1-0.2-1.7c0.1,0.6,0.1,1.2,0.2,1.7C594.9,387,594.9,387.4,594.9,387.6z"
									/>
								<path d="M564.7,475c-5.1-1.1-9.7-2.5-13.9-4.1C554.9,472.6,559.5,473.9,564.7,475z"/>
								<path d="M380.9,378c-2.9,5.7-6.8,10.5-11.1,14.6c-4.4,4.1-9.2,7.5-13.8,10.2c4.6-2.7,9.4-6.1,13.8-10.2
									C374.2,388.5,378.1,383.7,380.9,378z"/>
								<path d="M384.1,370.2c-0.1,0.2-0.2,0.5-0.2,0.7c0.1-0.2,0.1-0.3,0.2-0.5C384.1,370.4,384.1,370.3,384.1,370.2z"/>
								<path d="M357.7,437.8c0,0.4,0,0.8,0,1.3c0-0.3,0-0.5,0-0.8C357.7,438.1,357.7,437.9,357.7,437.8z"/>
								<polygon points="460.9,428.3 457.1,428.6 432,430.1 432,430.1 460.9,428.4 		"/>
								<path d="M295.7,430.9c0.4,0.1,0.8,0.3,1.2,0.5c-0.2-0.1-0.4-0.2-0.7-0.3C296,431,295.8,431,295.7,430.9z"/>
								<path d="M403.5,472.9c-3.3,0.9-6.4,1.8-9.5,2.7c-5.6,1.7-10.7,3.3-15.3,4.7c4.6-1.5,9.8-3.1,15.4-4.7
									C397,474.7,400.2,473.8,403.5,472.9z"/>
								<path d="M362.7,485.7c-0.5,0.2-1,0.3-1.4,0.5c-0.9,0.3-1.6,0.6-2.3,0.8c0.7-0.2,1.4-0.5,2.3-0.8
									C361.8,486,362.3,485.8,362.7,485.7z"/>
								<path d="M421.8,457.4l-4.3,11.6c-2.3,0.6-4.5,1.2-6.7,1.8c2.2-0.6,4.4-1.2,6.7-1.8L421.8,457.4z"/>
								<path d="M355.3,424.3L355.3,424.3c0,0.1,0.1,0.2,0.1,0.3C355.3,424.5,355.3,424.4,355.3,424.3z"/>
								<path d="M335.5,411.8L335.5,411.8L335.5,411.8z"/>
								<path d="M331.2,382.2l-7.9,16.2c3-1.5,6-3.4,8.7-5.8c2.9-2.6,5.5-5.7,7.6-9.5c-2-0.4-4-0.7-5.5-0.8
									C332.5,382.2,331.5,382.2,331.2,382.2z"/>
								<path d="M341.8,409.6c-0.6,0.3-1.2,0.5-1.8,0.7C340.6,410.1,341.2,409.9,341.8,409.6c0.5-0.2,1.1-0.4,1.6-0.7
									C342.9,409.2,342.3,409.4,341.8,409.6z"/>
								<path d="M355.7,455.5c-0.2,0.8-0.3,1.6-0.5,2.4C355.3,457.1,355.5,456.3,355.7,455.5L355.7,455.5z"/>
								<path d="M326.2,482.5c2-0.5,4.1-1,6.2-1.5c1.2-0.3,2.4-0.6,3.6-0.9c-1.2,0.3-2.4,0.6-3.6,0.9C330.3,481.5,328.2,482,326.2,482.5z"
									/>
								<path d="M341.3,371.1c-0.2-0.4-0.5-0.8-0.7-1.2C340.8,370.2,341.1,370.6,341.3,371.1L341.3,371.1z"/>
								<polygon points="301.1,404.4 301.1,404.4 311.6,383 302.2,402.1 		"/>
								<path d="M357.2,490.3l6.8,10.5c0.3-0.1,2.2-0.8,5.3-1.9c3.1-1.1,7.4-2.5,12.7-4.3c5.3-1.7,11.5-3.7,18.3-5.7
									c6.9-2,14.4-4.2,22.3-6.2l13.7-37l26-1.6l0.3,3.2l1.6,18l0,0l2.7,13.8c2.6-0.3,5.5-0.6,8.8-0.8s6.7-0.4,10.3-0.5
									c3.6-0.1,7.3-0.2,11-0.3c3.7-0.1,7.3-0.1,10.8-0.1c0.5,0,1,0,1.5,0s1,0,1.5,0s1,0,1.4,0c0.5,0,0.9,0,1.4,0l-0.1-13.8
									c-0.2,0-0.5,0-0.7,0c0.2,0,0.5,0,0.7,0l-6.1-27.2l-5-22.4l-2.9-13l-7.2-31.8H421l-12.5,22.9L391.4,423l-21.9,39.9l-7.1,13
									c0.5-2,1-4,1.5-6.2c1.1-5.3,1.9-11,1.9-16.4c0-5.5-0.9-10.7-3.1-14.9l-7.4-14.2c2.4-1.1,5-2.4,7.8-3.9c4.7-2.7,9.7-6.1,14.2-10.3
									c4.5-4.2,8.5-9.3,11.3-15.4c0.9-2,1.6-3.9,2.2-5.6c0.5-1.8,0.9-3.4,1.1-4.9s0.2-3,0.1-4.3s-0.4-2.5-0.8-3.7l-2.4-7H340
									c0.1,0.1,0.2,0.3,0.4,0.4c-0.1-0.1-0.2-0.3-0.4-0.4h-75l0.5,0.7l8,2.6c-3.5,5.6-7.8,12.6-12.7,20.5c-4.7,7.6-10,16.1-15.5,25
									l34,31.4l10.2-20c0.5,0,1,0.1,1.6,0.2c-0.6-0.1-1.1-0.2-1.6-0.2l-10.2,20l13.3,12.3l8.5-16.7c0.9,0.1,2.1,0.3,3.5,0.6
									c1.3,0.3,2.8,0.8,4.3,1.5c0,1.8-0.2,3.7-0.8,5.9c-0.4,1.6-1,3.3-1.9,5.1c-2,4.3-3.7,8-5.2,11.3l29.6,27.4
									c3.6-0.9,7.3-1.9,11.4-2.8C346.5,492.8,351.5,491.6,357.2,490.3z M510.3,463.5c0.2,0,0.3,0,0.5,0
									C510.7,463.5,510.5,463.5,510.3,463.5c-0.3,0-0.6,0-0.9,0C509.7,463.5,510,463.5,510.3,463.5z M495.8,463.6c2.4,0,4.9-0.1,7.3-0.1
									C500.7,463.5,498.3,463.5,495.8,463.6c-3.2,0.1-6.5,0.1-9.7,0.2C489.3,463.7,492.6,463.6,495.8,463.6z M473.4,464.4
									c1.4-0.1,2.9-0.2,4.4-0.2C476.4,464.2,474.8,464.3,473.4,464.4s-2.8,0.2-4.1,0.3C470.6,464.6,472,464.5,473.4,464.4z M457.6,387.3
									c0.3,4.1,0.7,8.6,1.1,13.4l-6.1,0.2L457.6,387.3z M432,430.1l25.1-1.5l3.9-0.2l0,0L432,430.1L432,430.1z M417.5,469.1l4.3-11.6
									L417.5,469.1c-2.3,0.6-4.5,1.2-6.7,1.8C413,470.2,415.2,469.7,417.5,469.1z M394,475.6c3-0.9,6.2-1.8,9.5-2.7
									C400.2,473.8,397,474.7,394,475.6c-5.6,1.7-10.7,3.3-15.3,4.7C383.3,478.9,388.4,477.3,394,475.6z M361.3,486.2
									c0.4-0.2,0.9-0.3,1.4-0.5C362.3,485.8,361.8,486,361.3,486.2c-0.9,0.3-1.6,0.6-2.3,0.8C359.7,486.7,360.5,486.5,361.3,486.2z
									M357.7,437.8c0,0.2,0,0.3,0,0.5c0,0.3,0,0.5,0,0.8C357.7,438.6,357.7,438.2,357.7,437.8z M384.1,370.2c0,0.1,0,0.2-0.1,0.2
									c0,0.2-0.1,0.3-0.2,0.5C384,370.7,384.1,370.5,384.1,370.2z M369.8,392.6c4.3-4.1,8.2-8.9,11.1-14.6
									C378.1,383.7,374.2,388.5,369.8,392.6c-4.4,4.1-9.2,7.5-13.8,10.2C360.6,400.1,365.4,396.8,369.8,392.6z M295.7,430.9
									c0.2,0.1,0.4,0.1,0.6,0.2s0.4,0.2,0.7,0.3C296.5,431.2,296.1,431,295.7,430.9z M355.3,424.3c0,0.1,0.1,0.2,0.1,0.3
									C355.3,424.5,355.3,424.4,355.3,424.3L355.3,424.3z M355.7,455.5L355.7,455.5c-0.2,0.8-0.3,1.6-0.5,2.4
									C355.3,457.1,355.5,456.3,355.7,455.5z M341.3,371.1L341.3,371.1c-0.2-0.4-0.5-0.8-0.7-1.2C340.8,370.2,341.1,370.6,341.3,371.1z
									M302.1,434.3c0.6,0.5,1.2,1,1.8,1.5l0.1,0.1C303.5,435.3,302.8,434.8,302.1,434.3z M301.1,404.4L301.1,404.4l1.1-2.2l9.4-19.1
									L301.1,404.4z M332.4,480.9c-2.1,0.5-4.2,1-6.2,1.5C328.2,482,330.3,481.5,332.4,480.9c1.2-0.3,2.4-0.6,3.6-0.9
									C334.8,480.4,333.6,480.7,332.4,480.9z M335.5,411.8L335.5,411.8L335.5,411.8L335.5,411.8z M332,392.6c-2.7,2.4-5.7,4.3-8.7,5.8
									l7.9-16.2c0.3,0,1.3,0,2.9,0.1c1.5,0.1,3.5,0.3,5.5,0.8C337.5,386.9,334.9,390,332,392.6z M340,410.3c0.6-0.2,1.2-0.4,1.8-0.7
									c0.5-0.2,1.1-0.4,1.6-0.7c-0.5,0.2-1.1,0.5-1.6,0.7C341.2,409.9,340.6,410.1,340,410.3z"/>
								<path d="M727,450.3l6.5,0.8l11.8-15.2l-26.7-3.3l0,0l26.7,3.3l2-13.5l1.6-10.7l-39.9-4.6l-2.2-0.2l-10.3-22.3l-0.3-0.7
									c3,0.3,6.5,0.6,10.5,1c6.8,0.7,13.1,2.4,18.9,4.5c5.7,2.2,10.8,4.8,15.1,7.4s7.7,5.1,10.2,7.1s3.9,3.3,4.2,3.6l12.9-17.6
									c-0.1-0.1-0.6-0.5-1.3-1.2c0.7,0.6,1.1,1,1.3,1.2l-13.1-20.8h-23.1c1.7,0.5,3.5,1.1,5.1,1.7c3.3,1.3,6.4,2.7,9.3,4.2
									c-2.9-1.5-6-2.9-9.3-4.2c-1.7-0.6-3.4-1.2-5.1-1.7h-80.9l11.8,33.4l5.8,16.3l1,2.7L650.9,369h-59.7c0.6,1.3,1.1,2.7,1.5,4.3
									c0.4,1.6,0.8,3.3,1.1,4.9c0.2,1.3,0.4,2.5,0.6,3.7c-0.2-1.1-0.4-2.4-0.6-3.7c-0.3-1.6-0.7-3.3-1.1-4.9c-0.4-1.6-0.9-3-1.5-4.3
									h-77.4c-1.5,3.4-2.3,6.9-2.3,10.4c0,4.6,0,9.5-0.1,14.5c0,0.1,0,0.1,0,0.2c-0.1,4.2-0.1,8.5-0.2,12.4c0,0.6,0,1.2,0,1.8
									c-0.1,4.5-0.1,8.7-0.1,12c0,0.9,0,1.7,0,2.4l0.3,15.7c0,0.5,0,1,0,1.5s0,0.9,0.1,1.3c0,0.4,0,0.8,0.1,1.1c0,0.3,0.1,0.6,0.1,0.8
									c0.2,1.1,0.8,4.3,2.5,8.7c1.8,4.4,4.7,9.8,9.4,15.2c4.8,5.4,11.3,10.8,20.4,15.1c9.1,4.3,20.7,7.4,35.5,8.3c0.5,0,1,0.1,1.5,0.1
									s1,0,1.5,0.1c0.5,0,1,0,1.4,0c0.5,0,0.9,0,1.4,0c6.9,0,12.6-0.8,17.2-2c4.6-1.2,8.2-2.8,10.8-4.4c2.7-1.6,4.5-3.2,5.7-4.5
									s1.7-2.2,1.8-2.3l45.6,39.2l8.2-11.7l0,0l-9.5-31.5l-15.4-50.7l-4.1-13.7l-1.6-5l-30-1.7l-15.4-0.8l32.1-16.6l4.5-13.7l3.7,2.4
									L681,492.7c4.6,1,9.2,2,13.7,3.1l37.5-34.6L727,450.3z M763.4,386.2c0.6,0.5,1.2,1,1.7,1.4C764.6,387.2,764.1,386.7,763.4,386.2
									c-1.2-0.9-2.6-2-4.3-3.2C760.8,384.2,762.2,385.3,763.4,386.2z M511.1,424.2v-0.1c0,0.1,0,0.2,0,0.2
									C511.1,424.3,511.1,424.3,511.1,424.2z M511.2,425.6v-0.1V425.6L511.2,425.6z M511.2,426.7c0,0,0-0.1,0-0.2
									C511.2,426.6,511.2,426.7,511.2,426.7C511.2,426.8,511.2,426.8,511.2,426.7z M511.3,427.6c0-0.1,0-0.1,0-0.2
									C511.3,427.5,511.3,427.6,511.3,427.6c0,0.1,0,0.2,0,0.2C511.4,427.8,511.3,427.7,511.3,427.6z M514,436.8
									c-0.9-2.2-1.5-4.1-1.9-5.6c0.3,1,0.6,2.1,1.1,3.4C513.4,435.3,513.7,436,514,436.8c1.2,2.9,2.9,6.3,5.2,9.9
									C516.9,443.1,515.2,439.7,514,436.8z M626.6,463.8l13.6,11.6L626.6,463.8c-0.1,0.2-0.6,0.9-1.5,2C626,464.8,626.5,464,626.6,463.8
									z M602.8,438.7c-0.1,0.5-0.2,0.9-0.3,1.3c0.1-0.6,0.3-1.1,0.4-1.7C602.8,438.5,602.8,438.6,602.8,438.7z M602.6,430.9
									c0,0.1,0,0.3,0.1,0.4c-0.1-0.5-0.2-1-0.3-1.4C602.5,430.2,602.6,430.5,602.6,430.9z M602.3,440.7v0.1c0,0,0,0,0,0.1V440.7z
									M594.8,386.3c0.1,0.7,0.1,1.1,0.1,1.4C594.9,387.4,594.9,387,594.8,386.3c-0.1-0.5-0.1-1-0.2-1.7
									C594.7,385.2,594.7,385.8,594.8,386.3z M550.7,470.9c4.2,1.6,8.8,3,13.9,4.1C559.5,473.9,554.9,472.6,550.7,470.9z M584.6,477.6
									L584.6,477.6L584.6,477.6L584.6,477.6z M586.5,449.8c-0.1,0-0.1,0-0.2,0s-0.1,0-0.2,0s-0.1,0-0.2,0c-0.1,0-0.1,0-0.2,0
									c-5.7-0.1-10.2-1.4-13.8-3.3s-6.2-4.5-8.1-7.4c-1.6-2.4-2.8-4.9-3.6-7.5c-0.2-0.5-0.3-1-0.5-1.5c-0.9-3-1.3-5.8-1.7-8.1
									c-0.5-3.6-1-8-1.4-12.6c-0.3-3.3-0.5-6.8-0.8-10.2c-0.1-1.3-0.2-2.6-0.2-3.9c-0.2-4-0.4-7.8-0.5-11c0,0,0,0,0-0.1
									c0.8-1.5,1.8-2.8,3-3.9c1.4-1.3,2.9-2.2,4.7-2.9c1.7-0.7,3.6-1,5.6-1c1.8,0,3.8,0.1,5.8,0.6c2,0.4,4,1.1,5.8,2.2
									c1.9,1.1,3.6,2.6,5.1,4.7s2.7,4.7,3.6,8c0.4,1.5,0.7,3.1,1,4.6s0.5,3,0.7,4.3c0,0.1,0,0.1,0,0.2l-18.8-1l0,0l-2.8,17.1l11,23.9
									l17.4,1.5c0.1,0.1,0.2,0.7,0.4,1.5c0.2,0.7,0.4,1.6,0.6,2.7C595.7,448.5,592,449.8,586.5,449.8z M583.2,425.2L583.2,425.2
									l-4.9-10.7L583.2,425.2z M689.9,479.7l-0.4-1L689.9,479.7L689.9,479.7z"/>
							</g>
							<g id="_x33_d_1_">
								<polygon fill="#7975BB" points="645.4,342.4 638.8,361.7 623.1,351.6 628.8,331.7 		"/>
								<polygon fill="#775FA6" points="281.3,347.9 293.3,367 265.5,358.1 252,338.5 		"/>
								<path fill="#702A71" d="M341.3,359.2l8.9,18.5c-0.9-1.9-2.5-3.2-4.3-4.3c-1.9-1-4.1-1.7-6.2-2.2s-4.1-0.7-5.7-0.8
									c-1.6-0.1-2.6-0.1-2.9-0.1l-10-18.9c0.3,0,1.4,0,3.1,0.1c1.6,0.1,3.8,0.4,6,0.9s4.5,1.2,6.5,2.3
									C338.7,355.8,340.4,357.3,341.3,359.2"/>
								<path fill="#702A71" d="M384.6,345.1l6.7,19.2c0.4,1.1,0.6,2.3,0.8,3.7c0.1,1.3,0.1,2.7-0.1,4.3c-0.2,1.5-0.6,3.2-1.1,4.9
									c-0.5,1.8-1.3,3.6-2.2,5.6l-6.9-18.3c1-2.1,1.7-4.1,2.3-5.9s1-3.6,1.2-5.2s0.3-3.1,0.1-4.5C385.3,347.5,385,346.3,384.6,345.1"/>
								<path fill="#702A71" d="M594.9,375.9l-4,17.7c0-0.1-0.1-0.6-0.1-1.4c-0.1-0.8-0.2-1.9-0.4-3.2c-0.2-1.3-0.4-2.8-0.7-4.3
									s-0.6-3.1-1-4.6c-0.9-3.3-2.1-5.9-3.6-8s-3.2-3.6-5.1-4.7s-3.9-1.8-5.8-2.2c-2-0.4-4-0.6-5.8-0.6c-2,0-3.8,0.3-5.6,1
									c-1.7,0.7-3.3,1.6-4.7,2.9s-2.5,2.8-3.4,4.6c-0.9,1.8-1.5,3.8-1.7,6.1l2-18.4c0.3-2.4,0.9-4.5,1.8-6.4c0.9-1.9,2.1-3.5,3.6-4.8
									c1.4-1.3,3.1-2.4,4.9-3.1c1.8-0.7,3.8-1.1,5.9-1.1c1.9,0,4,0.1,6.1,0.6c2.1,0.4,4.2,1.2,6.2,2.3c2,1.2,3.8,2.8,5.4,4.9
									c1.6,2.2,2.9,4.9,3.8,8.4c0.4,1.6,0.8,3.3,1.1,4.9s0.5,3.2,0.7,4.5c0.2,1.4,0.3,2.5,0.4,3.4C594.9,375.3,594.9,375.8,594.9,375.9"
									/>
								<polygon fill="#7760A6" points="636.8,354.3 630.6,373 590.9,393.6 594.9,375.9 		"/>
								<path fill="#702A71" d="M767.8,378.1l-12.9,17.6c-0.3-0.2-1.7-1.6-4.2-3.6s-5.9-4.5-10.2-7.1s-9.4-5.3-15.1-7.4
									c-5.7-2.2-12.1-3.9-18.9-4.5c-6.8-0.7-12-1.2-15.9-1.6c-4-0.4-6.7-0.6-8.6-0.8c-1.9-0.2-3-0.3-3.5-0.3c-0.6,0-0.7,0-0.7,0
									l8.7-18.9c0,0,0.1,0,0.8,0s1.7,0.1,3.7,0.3c2,0.2,4.9,0.4,9.1,0.9s9.7,0.9,16.8,1.7c7.2,0.7,13.8,2.5,19.9,4.8s11.4,5.1,15.9,7.8
									c4.5,2.7,8.2,5.4,10.8,7.5C766,376.4,767.6,377.9,767.8,378.1"/>
								<polygon fill="#744990" points="455.9,353 459,371.8 446.2,406.5 442.4,389.6 		"/>
								<polygon fill="#7971B8" points="321.2,351.4 331.2,370.3 312.1,409.4 301.1,392.5 		"/>
								<path fill="#702A71" d="M381.8,364.5l6.9,18.3c-2.8,6.1-6.8,11.2-11.3,15.4c-4.5,4.3-9.5,7.7-14.2,10.3c-4.7,2.7-9.1,4.6-12.4,5.9
									s-5.6,1.9-6,2l-9.3-16.5c0.4-0.1,2.8-0.8,6.3-2.2c3.5-1.3,8.1-3.4,13.1-6.2c4.9-2.8,10.2-6.4,14.9-10.9
									C374.6,376.3,378.8,370.9,381.8,364.5"/>
								<polygon fill="#73448A" points="583.2,413.3 579.8,429.1 568.8,405.2 571.6,388.2 		"/>
								<polygon fill="#7867AE" points="601.6,414.9 597.2,430.6 579.8,429.1 583.2,413.3 		"/>
								<polygon fill="#7867AD" points="461,416.5 463.8,432.1 436.3,433.8 432,418.3 		"/>
								<polygon fill="#786AB0" points="745.3,424 733.5,439.2 708.1,436.1 718.5,420.7 		"/>
								<path fill="#702A71" d="M306,426.3l10.8,15.1c-1-1.4-2.3-2.7-3.7-3.7c-1.4-1-2.9-1.8-4.4-2.5s-2.9-1.1-4.3-1.5
									c-1.3-0.3-2.5-0.6-3.5-0.6l-11.6-15.6c1,0.1,2.2,0.3,3.7,0.7c1.4,0.4,3,0.9,4.5,1.6c1.6,0.7,3.1,1.6,4.6,2.6
									C303.6,423.5,304.9,424.8,306,426.3"/>
								<path fill="#702A71" d="M602.4,428.6l-4.4,15c0.4-1.4,0.6-2.9,0.6-4.4c0-1.4-0.1-2.8-0.3-4.1c-0.2-1.2-0.4-2.3-0.6-3.1
									c-0.2-0.8-0.4-1.3-0.4-1.5l4.4-15.7c0.1,0.2,0.2,0.7,0.5,1.6c0.2,0.8,0.5,2,0.7,3.2c0.2,1.3,0.3,2.8,0.3,4.3
									C603,425.5,602.8,427.1,602.4,428.6"/>
								<path fill="#702A71" d="M803.8,451.5L789,465.3c0.5-0.5,1-1,1.4-1.6s0.7-1.2,1-1.9c0.3-0.7,0.5-1.4,0.6-2.1
									c0.1-0.8,0.1-1.6,0.1-2.4l15-14.3c0.1,0.9,0,1.8-0.1,2.6c-0.1,0.8-0.3,1.6-0.6,2.3c-0.3,0.7-0.6,1.4-1.1,2
									C804.9,450.4,804.4,451,803.8,451.5"/>
								<path fill="#702A71" d="M513.3,451.7l0.1,13.8c-0.5,0-0.9,0-1.4,0s-1,0-1.4,0c-0.5,0-1,0-1.5,0s-1,0-1.5,0c-3.5,0-7.1,0-10.8,0.1
									c-3.7,0.1-7.4,0.1-11,0.3c-3.6,0.1-7.1,0.3-10.3,0.5c-3.2,0.2-6.2,0.5-8.8,0.8l-2.7-13.8c2.7-0.3,5.8-0.6,9.2-0.8
									c3.4-0.2,7-0.4,10.8-0.5s7.7-0.2,11.6-0.3c3.9-0.1,7.7-0.1,11.4-0.1c0.5,0,1.1,0,1.6,0s1,0,1.5,0s1,0,1.5,0
									C512.3,451.7,512.8,451.7,513.3,451.7"/>
								<polygon fill="#744990" points="432,418.3 436.3,433.8 422.6,470.8 417.5,457.2 		"/>
								<g id="XMLID_2_">
									<g>
										<path fill="#7971B8" d="M362.7,426.6c2.2,4.2,3.1,9.5,3.1,14.9c0,5.5-0.8,11.2-1.9,16.4c-1.1,5.2-2.5,10.1-3.7,13.7
											s-2.2,6.1-2.4,6.6l-8.6-13.2c0.2-0.6,1.3-3.2,2.5-7c1.3-3.8,2.8-8.9,3.9-14.4c1.2-5.5,2-11.6,2-17.3c0-5.8-0.9-11.2-3.2-15.7
											L362.7,426.6z"/>
									</g>
								</g>
								<path fill="#702A71" d="M626.6,452l-5.7,13.8c-0.1,0.2-0.6,1.1-1.8,2.3c-1.2,1.3-3,2.9-5.7,4.5s-6.2,3.2-10.8,4.4
									c-4.6,1.2-10.3,2-17.2,2c-0.5,0-0.9,0-1.4,0s-0.9,0-1.4,0s-1,0-1.5-0.1c-0.5,0-1,0-1.5-0.1c-14.8-0.9-26.4-4-35.5-8.3
									s-15.7-9.7-20.4-15.1c-4.8-5.4-7.7-10.9-9.4-15.2c-1.8-4.4-2.4-7.6-2.5-8.7c0-0.2-0.1-0.5-0.1-0.8s0-0.7-0.1-1.1
									c0-0.4,0-0.8-0.1-1.3c0-0.5,0-1,0-1.5l-0.3-15.9c0,0.6,0,1.1,0,1.6s0,1,0.1,1.4c0,0.4,0,0.8,0.1,1.1c0,0.3,0.1,0.6,0.1,0.9
									c0.2,1.1,0.8,4.6,2.7,9.2s4.9,10.3,10,16c5,5.7,12,11.4,21.6,15.9s21.9,7.8,37.5,8.8c0.5,0,1,0.1,1.6,0.1c0.5,0,1,0,1.5,0.1
									s1,0,1.5,0s1,0,1.5,0c7.3,0,13.3-0.8,18.2-2.1c4.9-1.2,8.6-2.9,11.4-4.6s4.8-3.4,6-4.7C625.9,453.1,626.5,452.2,626.6,452"/>
								<polygon fill="#755399" points="689.9,467.8 680.9,480.8 638.8,361.7 645.4,342.4 		"/>
								<path fill="#702A71" d="M349.2,465.1l8.6,13.2c-5.9,1.4-11.2,2.6-15.9,3.8c-4.8,1.2-9.1,2.2-13.4,3.4c-4.2,1.1-8.4,2.3-12.7,3.5
									c-4.3,1.3-8.9,2.7-13.9,4.3L290.3,481c5.3-1.7,10.1-3.2,14.7-4.5s8.9-2.5,13.4-3.7s9.1-2.3,14.1-3.5
									C337.5,467.9,342.9,466.6,349.2,465.1"/>
								<path fill="#702A71" d="M417.5,457.2l5.1,13.6c-7.9,2.1-15.4,4.2-22.3,6.2s-13.1,4-18.3,5.7c-5.3,1.7-9.6,3.2-12.7,4.3
									c-3.1,1.1-4.9,1.8-5.3,1.9l-8.2-12.6c0.4-0.1,2.3-0.8,5.6-2c3.2-1.1,7.8-2.7,13.3-4.5s12.1-3.9,19.3-6
									C401.2,461.6,409.2,459.4,417.5,457.2"/>
								<polygon fill="#7972B8" points="289.4,417.5 301,433.1 265.4,503.3 251.8,491.5 		"/>
								<polygon fill="#765CA2" points="674.7,493.3 666.5,505 620.9,465.8 626.6,452 		"/>
								<path fill="#702A71" d="M251.8,491.5l13.6,11.8c-11.3,3.8-21.4,7.3-30.4,10.6s-16.7,6.2-23,8.8c-6.4,2.5-11.4,4.6-14.9,6.1
									s-5.5,2.4-5.9,2.5L173.6,521c0.4-0.2,2.5-1.1,6.2-2.7c3.7-1.6,9-3.7,15.7-6.4s14.9-5.8,24.3-9.2
									C229.2,499.3,239.9,495.5,251.8,491.5"/>
								<path fill="#702A71" d="M858.5,525.2l-17.6,10.1c-1-0.5-6.3-3-14.9-6.9c-8.7-3.8-20.8-9-35.3-14.6c-14.6-5.6-31.6-11.7-50.2-17.5
									c-18.6-5.8-38.7-11.2-59.4-15.6l8.9-13c21.9,4.6,43.1,10.3,62.7,16.4c19.6,6.1,37.5,12.5,52.9,18.4s28.1,11.3,37.3,15.4
									C851.9,522.1,857.5,524.8,858.5,525.2"/>
							</g>
							<path fill="#70CEEF" d="M385.4,349.3c-0.2-4.2-1.9-7.3-4.4-9.7c-0.054-0.022-0.113-0.038-0.167-0.059
								c-2.497-2.368-6.068-4.049-10.133-4.941c-4.2-1.1-8.9-1.5-13.8-1.5c-0.2,0-0.4,0-0.6,0s-0.4,0-0.6,0s-0.4,0-0.6,0s-0.4,0-0.6,0
								c-5.2,0.2-14,0.6-24.3,1.1c-10.2,0.5-22,1.2-33.3,1.8c-11.3,0.6-22,1.2-30.2,1.7c-8.1,0.5-13.8,0.8-14.8,0.9l29.4,9.3
								c-2.7,4.4-46.1,74.7-55.8,90.2c-3.755,5.969-7.416,11.933-11.075,17.724c-0.142,0.125-0.283,0.252-0.425,0.376
								c-8.4,13.4-16.3,26.2-22.9,36.7c-9.6,15.3-16.3,26-17.5,28c0.4-0.2,2.5-1.1,6.2-2.7c3.7-1.6,9-3.8,15.7-6.4s14.9-5.8,24.3-9.2
								c9.5-3.5,20.2-7.2,32.1-11.2l37.5-74c1.7,0.2,4.2,0.7,6.9,1.7c2.6,1,5.4,2.5,7.7,4.7c2.3,2.2,4,5.1,4.6,8.7
								c0.5,3.7-0.1,8.1-2.6,13.6c-3.8,8.2-6.6,14.4-8.8,19.2s-3.7,8.1-4.7,10.4s-1.6,3.6-1.9,4.3c-0.3,0.7-0.4,0.9-0.4,0.9
								c5.4-1.7,10.1-3.2,14.7-4.5s8.9-2.5,13.4-3.7c4.5-1.1,9.1-2.3,14.1-3.5s10.5-2.5,16.8-4c0.3-0.8,2.1-5.2,3.9-11.3
								c1.9-6.2,3.8-14,4.4-21.9s0-15.7-3.2-21.6c-1.6-2.9-3.7-5.3-6.5-7.2l-0.157,0.21c-3.174-1.943-7.124-3.113-12.143-3.31
								c0.4-0.2,2.8-0.8,6.3-2.2s8.2-3.4,13.1-6.2c4.9-2.8,10.1-6.4,14.9-10.9c1.2-1.2,2.4-2.4,3.5-3.6l0,0c2-2.2,3.9-4.7,5.6-7.4
								c1.1-1.6,2.1-3.4,2.9-5.2C384.6,358.4,385.7,353.4,385.4,349.3z M332.1,381c-3.3,2.8-7,5-10.7,6.7s-7.5,2.8-11,3.6
								s-6.7,1.2-9.2,1.4l2.6-5.2c0.022-0.201,0.037-0.434,0.039-0.685l2.961-6.015l14.4-29.4c0.3,0,2.2,0,4.8,0.3c2.6,0.3,5.7,0.8,8.6,2
								s5.4,2.9,6.7,5.5c1.2,2.6,1.2,6.1-1,10.7c-0.3,0.6-0.6,1.2-0.9,1.8l0,0C337.8,374.6,332.6,380.6,332.1,381z M373.312,377.175
								c0.139-0.265,0.21-0.556,0.193-0.841C373.524,376.616,373.453,376.906,373.312,377.175z"/>
							<path fill="#70CEEF" d="M485.9,329.7l-50.5,0.9l-79.5,145.8c0.4-0.1,2.3-0.9,5.6-2c3.2-1.1,7.8-2.7,13.3-4.5s12.1-3.9,19.3-6
								c7.2-2.2,15.2-4.4,23.5-6.6l14.5-39l29-1.8l3.2,36.9c2.7-0.3,5.8-0.6,9.2-0.8c3.4-0.2,7-0.4,10.8-0.5s7.7-0.2,11.6-0.3
								c3.9-0.1,7.7-0.1,11.4-0.1c0.6,0,1.1,0,1.6,0s1,0,1.5,0s1,0,1.5,0c0.5,0,1,0,1.5,0L485.9,329.7z M458.6,388.7l-16.1,0.6l-0.2,0.2
								l13.6-36.6C455.9,353.1,458.2,383.8,458.6,388.7z"/>
							<path fill="#70CEEF" d="M816.2,457.6L816.2,457.6l-9.1-14.6c0.2,2.9-0.6,5.2-2,7.2c-1.4,1.9-3.5,3.3-6,4.4c-2.5,1-5.4,1.7-8.5,2.2
								c-1.418,0.213-2.888,0.323-4.371,0.406c-0.62-0.094-1.258-0.14-1.929-0.106c-1.1,0.1-2.2,0.1-3.2,0.1c-1.2,0-2.4-0.1-3.6-0.1
								s-2.3-0.1-3.4-0.2s-2.1-0.2-3.1-0.3c-1-0.1-1.9-0.3-2.7-0.4c-2.6-0.5-6.1-1-9.9-1.7c-3.7-0.6-7.8-1.3-11.5-2
								c-3.8-0.6-7.2-1.2-9.8-1.7c-2.5-0.4-4.3-0.8-4.6-0.8l-5.8-12.2c-0.016,0.002-0.03,0.001-0.046,0.003L718.5,420.7l26.7,3.3l3.6-24.2
								l-42.2-4.6l-20.2-43.9c0.1,0,0.2,0,0.8,0s1.7,0.1,3.7,0.3c2,0.2,4.9,0.5,9.1,0.9c4.2,0.4,9.6,1,16.8,1.7s13.9,2.5,19.9,4.8
								s11.4,5.1,15.9,7.8s8.2,5.4,10.8,7.5s4.1,3.5,4.4,3.8l-25.7-40.9l-113.2-5.6l16.488,10.628c-0.029-0.01-0.059-0.018-0.088-0.028
								l44.5,125.6c21.9,4.6,43.1,10.3,62.7,16.4c19.6,6.1,37.6,12.5,52.9,18.4c15.4,6,28.1,11.3,37.3,15.4c9.2,4,14.8,6.7,15.8,7.2
								L816.2,457.6z"/>
							<path fill="#70CEEF" d="M655.7,430.7L644,392.1l-72.3-4l11.585,25.168c-0.029,0.011-0.057,0.021-0.085,0.032l18.3,1.6
								c0.1,0.3,0.6,1.9,1,4.1s0.7,5.1,0.2,7.9s-1.7,5.5-4.2,7.6c-2.6,2-6.4,3.4-12.1,3.4c-0.1,0-0.1,0-0.2,0s-0.1,0-0.2,0s-0.1,0-0.2,0
								c-0.1,0-0.1,0-0.2,0c-5.7-0.2-10.2-1.4-13.8-3.3s-6.2-4.5-8.1-7.4c-2-2.9-3.2-6-4.1-9c-0.477-1.716-0.856-3.427-1.151-5.057
								c0.051-0.016,0.099-0.026,0.151-0.043c-0.2-1-0.4-1.9-0.5-2.8c-0.6-3.6-1-8.1-1.4-12.6c-0.4-4.7-0.7-9.6-1-14.2
								c-0.2-3.6-0.4-7.1-0.5-10.1c0,0-0.2-1.7-0.1-2.4c-0.1-2.5-0.4-7.3-0.4-7.7c0-2.7,0.5-5.2,1.3-7.4s2-4,3.5-5.6s3.3-2.8,5.2-3.6
								c1.9-0.9,4.1-1.3,6.3-1.3c1.9,0,4,0.2,6.1,0.6s4.2,1.1,6.2,2.3c2,1.1,3.8,2.7,5.4,4.9c1.6,2.2,2.9,4.9,3.8,8.4
								c0.893,0.893,0.913,0.96,0,0.1c0.4,1.6,0.8,3.3,1.1,4.9c0.2,1,0.4,1.9,0.5,2.8c0,0,0.033,0.161,0.129,0.412
								c0.031,0.457,0.094,0.904,0.171,1.288c0.2,1.4,0.3,2.5,0.4,3.4c0.1,0.9,0.1,1.4,0.1,1.5l6.7-3.5l35.2-18.2c-0.2-0.3-1.5-1.9-4.3-4
								c-2.4-2.2-6-5.1-10.8-8c-1.5-1-1.7-1.3-4.8-3c-3.7-2-8.1-3.8-13.1-5.6c-7.4-2.4-16.1-4.3-26.3-5c-0.6,0-1.2-0.1-1.8-0.1
								c-0.6-0.1-1.2-0.1-1.8-0.1c-0.5,0-1.1,0-1.7,0c-0.5,0-1.1,0-1.7,0c-9.2,0-17.4,1.3-24.7,3.5c-4.5,1.4-8.7,3.2-12.4,5.2
								c0,0-4.6,2.7-6.5,4.1c-5.1,3.8-9,8.1-11.7,12.6c-1.8,3-3,6.2-3.6,9.3h0.1c0.03,0.056,0.061,0.103,0.091,0.154
								c-0.292,1.482-0.391,2.964-0.391,4.446c0.031,0.119,0.065,0.22,0.1,0.322c0,4.508-0.002,9.293-0.1,14.178
								c-0.1,4.2-0.5,22.9-0.5,26.2c0,3.4,0.1,5.9,0.3,7.2c0.2,1.2,0.8,4.6,2.7,9.2s5,10.4,10,16.1c5.1,5.7,12,11.4,21.6,15.9
								s21.9,7.8,37.5,8.8c0.6,0.1,1.1,0.1,1.6,0.1c0.5,0.1,1,0.1,1.5,0.1s1,0,1.5,0s1,0,1.5,0c7.4,0,13.3-0.9,18.2-2.1
								c4.8-1.3,8.6-2.9,11.4-4.6s4.8-3.4,6-4.7c1.2-1.4,1.8-2.3,1.9-2.5l48.1,41.2L655.7,430.7z"/>
							<path fill="#A6EEFF" d="M816.2,457.6l42.3,67.6c-1-0.5-6.6-3.2-15.8-7.2c-9.2-4.1-21.9-9.4-37.3-15.4
								c-15.3-5.9-33.3-12.3-52.9-18.4c-19.6-6.1-40.8-11.8-62.7-16.4l-13.3-37.6l0.2-0.1c8.6-5.9,12.3-26.5,24.8-16.1
								c12.4,10.3,14,25,25.2,23.8l5.8,12.2c0.3,0,2.1,0.4,4.6,0.8c2.6,0.5,6,1.1,9.8,1.7c3.7,0.7,7.8,1.4,11.5,2c3.8,0.7,7.3,1.2,9.9,1.7
								c0.8,0.1,1.7,0.3,2.7,0.4s2,0.2,3.1,0.3c1.1,0.1,2.2,0.2,3.4,0.2s2.4,0.1,3.6,0.1c1,0,2.1,0,3.2-0.1l0,0c5.9-0.3,9.5,5,16.7,4.6
								C807.8,461.6,813.5,455.4,816.2,457.6z"/>
							<path fill="#70CEEF" d="M807.1,443l9.1,14.6c-2.7-2.2-8.4,4-15.1,4.3c-7.2,0.3-10.8-5-16.7-4.6l0,0c2.1-0.1,4.2-0.2,6.2-0.5
								c3.1-0.5,6-1.2,8.5-2.2c2.5-1.1,4.6-2.5,6-4.4C806.5,448.2,807.3,445.9,807.1,443z"/>
							<path fill="#B6E5FF" d="M750.6,350.7l17.2,27.4c-0.3-0.3-1.8-1.7-4.4-3.8c-2.6-2.1-6.3-4.8-10.8-7.5s-9.9-5.5-15.9-7.8
								s-12.7-4.1-19.9-4.8c-7.2-0.7-12.6-1.3-16.8-1.7c-4.2-0.4-7.1-0.7-9.1-0.9c-2-0.2-3.1-0.3-3.7-0.3c-0.6,0-0.7,0-0.8,0l14.4,31
								c-10.6,15.7-35-18.1-45.2-11l-10.3-29.1c11.7,4.1,23.1-4.8,38.2-4.3c1.1,0,2.2,0.1,3.3,0.2C703.7,340.2,731.5,353.9,750.6,350.7
								L750.6,350.7z"/>
							<path fill="#E3FBFF" d="M742.1,337.2l8.5,13.5l0,0c-19.1,3.1-46.9-10.5-63.6-12.5c-1.1-0.1-2.2-0.2-3.3-0.2l0.2-3.6L742.1,337.2z"
								/>
							<path fill="#70CEEF" d="M748.8,399.8l-3.6,24.2l-26.7-3.3l8.2,17.2c-11.2,1.2-12.7-13.5-25.2-23.8c-12.5-10.4-16.3,10.2-24.8,16.1
								l-0.2,0.1l-19.8-56l0,0c3.5-1.2,7.2,0.4,12.8,7.6c5.7,7.2,10.5,5.7,14.8,6s6.5,4.8,10.4,4.2c3.9-0.6,3.8-6.1,8.3-4.6l0,0l3.6,7.7
								L748.8,399.8z"/>
							<path fill="#5CBBE5" d="M700.9,382.4l2.3,4.9l0,0c-4.5-1.5-4.4,4-8.3,4.6c-4,0.6-6.2-3.9-10.4-4.2c-4.3-0.3-9.1,1.2-14.8-6
								s-9.4-8.8-12.8-7.6l0,0l-1-2.8C665.9,364.4,690.3,398.2,700.9,382.4z"/>
							<path fill="#E3FBFF" d="M683.9,334.4l-0.2,3.6c-15.1-0.4-26.6,8.5-38.2,4.3l-16.6-10.7L683.9,334.4z"/>
							<path fill="#A6EEFF" d="M655.7,430.7l19,62.5L626.6,452c-0.1,0.2-0.7,1.1-1.9,2.5c-1.2,1.3-3.2,3-6,4.7s-6.6,3.3-11.4,4.6
								c-4.9,1.2-10.8,2.1-18.2,2.1c-0.5,0-1,0-1.5,0s-1,0-1.5,0s-1,0-1.5-0.1c-0.5,0-1,0-1.6-0.1c-15.6-1-27.9-4.3-37.5-8.8
								S529,446.7,523.9,441c-5-5.7-8.1-11.5-10-16.1s-2.5-8-2.7-9.2c-0.2-1.3-0.3-3.8-0.3-7.2c0-3.3,0-7.4,0.1-12c0-0.7,0-1.4,0-2.1
								c6,11,18.3-0.6,28.3,5.4c10,6.1,10.4,15.9,19.1,13.1c0.3,1.7,0.7,3.5,1.2,5.3c0.9,3,2.1,6.1,4.1,9c1.9,2.9,4.5,5.5,8.1,7.4
								s8.1,3.1,13.8,3.3c0.1,0,0.1,0,0.2,0c0.1,0,0.1,0,0.2,0s0.1,0,0.2,0s0.1,0,0.2,0c5.7,0,9.5-1.4,12.1-3.4c2.5-2.1,3.7-4.8,4.2-7.6
								c0.5-2.8,0.2-5.7-0.2-7.9c-0.4-2.2-0.9-3.8-1-4.1l-18.3-1.6c16.9-6.3,29.5-13.1,41.7-0.6C637,425.1,648,433.5,655.7,430.7z"/>
							<path fill="#70CEEF" d="M644,392.1l11.7,38.6c-7.7,2.8-18.7-5.6-30.7-18c-12.2-12.5-24.8-5.7-41.7,0.6l-11.6-25.2L644,392.1z"/>
							<path fill="#A6EEFF" d="M636.8,354.3L618,364c-8.6,3.3-22.1,1-25.5-2.4c-0.9-3.5-2.2-6.2-3.8-8.4c-1.6-2.2-3.4-3.8-5.4-4.9
								c-2-1.2-4.1-1.9-6.2-2.3c-2.1-0.4-4.2-0.6-6.1-0.6c-2.2,0-4.4,0.4-6.3,1.3c-1.9,0.8-3.7,2-5.2,3.6s-2.7,3.4-3.5,5.6
								s-1.3,4.7-1.3,7.4c0,0.4,0,0.9,0,1.4h-0.1c-7.7,4-10.4-5.3-24.3-5c-13.8,0.3-16.7,7.1-18.6,3.5h-0.1c0.6-3.1,1.8-6.3,3.6-9.3
								c2.7-4.5,6.6-8.8,11.7-12.6c1.9-1.4,4-2.7,6.2-4l0.1,0.2c16.9-1.2,40.9,5.1,54.3,2.8c13.3-2.3,19.9-3.3,29.1-0.8v-0.1
								c1.9,0.9,3.6,1.9,5.1,2.9c4.8,2.9,8.4,5.8,10.8,8C635.3,352.4,636.6,354,636.8,354.3z"/>
							<path fill="#5CBBE5" d="M618,364l-16.4,8.5l0,0c-6.6,1.4-7.5-3.1-7.5-3.1c-0.1-0.9-0.3-1.8-0.5-2.8c-0.3-1.6-0.7-3.3-1.1-4.9
								C596,365,609.4,367.3,618,364z"/>
							<path fill="#E3FBFF" d="M616.9,339.3L616.9,339.3c-9.3-2.4-15.8-1.4-29.1,0.9s-37.3-3.9-54.3-2.8l-0.1-0.2c3.7-2,7.9-3.8,12.4-5.2
								c7.3-2.2,15.5-3.5,24.7-3.5c0.6,0,1.2,0,1.7,0c0.6,0,1.2,0,1.7,0c0.6,0,1.2,0,1.8,0.1c0.6,0,1.2,0.1,1.8,0.1
								c10.2,0.7,18.9,2.6,26.3,5C608.8,335.5,613.2,337.3,616.9,339.3z"/>
							<path fill="#42A5E2" d="M601.6,372.5l-6.7,3.5c0-0.1,0-0.6-0.1-1.5s-0.2-2-0.4-3.4c-0.1-0.5-0.2-1.1-0.2-1.7
								C594.1,369.3,595,373.9,601.6,372.5L601.6,372.5z"/>
							<path fill="#70CEEF" d="M558.1,410.3c0.1,0.9,0.3,1.8,0.5,2.8c-8.7,2.8-9.1-7.1-19.1-13.1c-9.9-6-22.3,5.5-28.3-5.4
								c0.1-3.9,0.1-8.1,0.2-12.3c0.1-5,0.1-9.9,0.1-14.5c1.2,5,5.8-5.4,18.7-5.7c12.8-0.2,19.6,16.9,24.9,11.3h0.1
								c0.1,3,0.3,6.5,0.5,10.1c0.3,4.6,0.6,9.5,1,14.2C557.1,402.2,557.5,406.7,558.1,410.3z"/>
							<path fill="#5CBBE5" d="M555.1,373.4L555.1,373.4c-5.4,5.5-12.2-11.6-25-11.3c-12.8,0.2-17.4,10.7-18.7,5.7c0-1.5,0.1-3,0.4-4.5
								h0.1c1.9,3.6,4.8-3.1,18.6-3.5c13.8-0.3,16.5,9.1,24.3,5h0.1c0,1.5,0.1,3.7,0.2,6.2C555,371.7,555.1,372.5,555.1,373.4z"/>
							<path fill="#A6EEFF" d="M503.2,406.5l10.2,45.2c-0.5,0-1,0-1.5,0s-1,0-1.5,0s-1,0-1.5,0s-1,0-1.6,0c-3.7,0-7.5,0-11.4,0.1
								s-7.8,0.2-11.6,0.3c-3.8,0.1-7.4,0.3-10.8,0.5s-6.5,0.5-9.2,0.8l-3.2-36.9l-29,1.8l-14.5,39c-8.3,2.2-16.3,4.4-23.5,6.6
								c-7.2,2.1-13.8,4.2-19.3,6s-10.1,3.4-13.3,4.5c-3.3,1.1-5.2,1.9-5.6,2l36.4-66.7c7.5-9.5,15.5-16.3,26.4-15.1
								c11,1.2,9.2,6.9,24.5,5.9s21.4-13.5,34.9-16.1C484.1,383.1,497.7,382.2,503.2,406.5L503.2,406.5z"/>
							<path fill="#70CEEF" d="M494.2,366.9l8.9,39.5l0,0c-5.4-24.3-19-23.4-25.2-22.2c-13.5,2.6-19.6,15.1-34.9,16.1s-13.5-4.8-24.5-5.9
								c-10.9-1.1-18.9,5.6-26.4,15.1l21-38.3c6.1,0,9.5,2.4,16.6,1.7c7.1-0.7,15.5-4.2,19.2-1.5l0,0l-6.6,18.1l0.2-0.2l16.1-0.6
								c-0.4-4.9-0.8-9.5-1.1-13.7c0-0.5-0.1-1-0.1-1.4C460.2,376.1,481.7,378.2,494.2,366.9L494.2,366.9z"/>
							<path fill="#5CBBE5" d="M494,365.6l0.3,1.3h-0.1c-12.4,11.2-34,9.1-36.7,6.7c-0.3-3.3-0.5-6.4-0.7-9
								C462.4,363.8,473.5,372.7,494,365.6z"/>
							<path fill="#A6EEFF" d="M488.6,341.8l5.4,23.8c-20.5,7-31.6-1.9-37.2-1c0-0.3,0-0.5-0.1-0.8c-0.2-3.2-0.5-5.8-0.6-7.7
								c-0.1-1.9-0.2-3-0.2-3.2l-4.5,12.1c-3.8,0.2-13.3,5.8-21.8,6.2c-8.4,0.3-7.6-5.2-14-4.4l16.1-29.4c12.9,6.6,9.8,17.1,29.2,10.8
								C480.2,342,478.6,334.5,488.6,341.8z"/>
							<path fill="#E3FBFF" d="M485.9,329.7l2.7,12.1c-10-7.3-8.4,0.2-27.7,6.4c-19.4,6.2-16.3-4.2-29.2-10.8l3.7-6.8L485.9,329.7z"/>
							<path fill="#5CBBE5" d="M451.4,365.1l-2.3,6.4l0,0c-3.8-2.7-12.2,0.7-19.2,1.5c-7.1,0.7-10.5-1.7-16.6-1.7l2.4-4.4
								c6.5-0.7,5.6,4.8,14,4.4C438.1,371,447.6,365.3,451.4,365.1z"/>
							<path fill="#A6EEFF" d="M385.4,349.3c0.3,4.1-0.8,9.1-3.6,15.3c-0.8,1.8-1.8,3.6-2.9,5.2c-8.4,7.1-34.6,5.8-39.4,2l-0.1-0.1
								c0.3-0.6,0.6-1.2,0.9-1.8c2.2-4.6,2.2-8.1,1-10.7c-1.3-2.6-3.8-4.3-6.7-5.5c-2.9-1.2-6-1.7-8.6-2s-4.5-0.3-4.8-0.3l-14.4,29.4
								c-17.8-7.1-43.9,12.2-50.7,7.9c1.6-2.6,3.2-5.1,4.7-7.5c10.2-16.4,17.8-28.9,20.5-33.3l-14.2-4.5c26.1-1.8,26.8,0,47.8,2
								s52.4-11.4,66.1-5.8C383.5,342,385.2,345.1,385.4,349.3z"/>
							<path fill="#5CBBE5" d="M378.9,369.8c-1.7,2.7-3.6,5.2-5.6,7.4c0.6-1.1,0-2.6-3.1-2.3c-3.2,0.4-9.6,7.3-18.6,7.2
								c-9-0.1-7.4-5.9-9.5-6.5s-4.8,1.4-8.5,3.9l-0.1-0.1c2.3-2.2,4.3-4.8,5.9-7.7l0.1,0.1C344.3,375.5,370.5,376.9,378.9,369.8z"/>
							<path fill="#E3FBFF" d="M380.9,339.6c-13.6-5.6-45,7.7-66.1,5.8c-21-2-21.7-3.8-47.8-2l-15.1-4.8c1-0.1,6.7-0.4,14.8-0.9
								c8.2-0.5,18.9-1.1,30.2-1.7c11.3-0.6,23.1-1.3,33.3-1.8c10.3-0.5,19.1-0.9,24.3-1.1c0.2,0,0.4,0,0.6,0s0.4,0,0.6,0s0.4,0,0.6,0
								s0.4,0,0.6,0c4.9,0,9.6,0.4,13.8,1.5C374.8,335.5,378.4,337.2,380.9,339.6z"/>
							<path fill="#70CEEF" d="M370.2,374.9c3.1-0.4,3.7,1.2,3.1,2.3c-1.1,1.2-2.3,2.4-3.5,3.6c-4.8,4.5-10,8.1-14.9,10.9
								s-9.6,4.8-13.1,6.2c-3.5,1.4-5.9,2-6.3,2.2c5.1,0.2,9.1,1.4,12.3,3.4l-0.3,0.4c-8.1,11.6-33.8,14.1-60.7,6.2
								c-26.9-7.9-48.6,25.2-72.8,46.4l0,0c3.8-6,7.6-12.2,11.5-18.4c9.7-15.5,19.4-31.2,28.1-45.1c4.2,5.4,30.8-10.9,41.7-11.2
								c8.5-0.3,8.7,3.9,8.5,5.7l-2.6,5.2c2.5-0.2,5.7-0.6,9.2-1.4s7.3-1.9,11-3.6s7.4-3.9,10.7-6.7c0.5-0.4,1-0.9,1.5-1.4l0.1,0.1
								c3.7-2.6,6.4-4.6,8.5-3.9c2.1,0.6,0.5,6.4,9.5,6.5C360.6,382.2,367,375.3,370.2,374.9z"/>
							<path fill="#A6EEFF" d="M354.3,410.4c3.2,5.9,3.8,13.7,3.2,21.6c-0.6,7.9-2.5,15.7-4.4,21.9c-1.8,6.1-3.6,10.5-3.9,11.3
								c-6.3,1.5-11.8,2.8-16.8,4s-9.6,2.4-14.1,3.5c-4.5,1.2-8.8,2.4-13.4,3.7c-4.6,1.3-9.3,2.8-14.7,4.5c0,0,0.1-0.2,0.4-0.9
								c0.3-0.7,0.9-2,1.9-4.3s2.5-5.6,4.7-10.4s5-11,8.8-19.2c2.5-5.5,3.1-9.9,2.6-13.6c-0.6-3.6-2.3-6.5-4.6-8.7
								c-2.3-2.2-5.1-3.7-7.7-4.7c-2.7-1-5.2-1.5-6.9-1.7l-37.5,74c-11.9,4-22.6,7.7-32.1,11.2c-9.4,3.4-17.6,6.6-24.3,9.2
								c-6.7,2.6-12,4.8-15.7,6.4c-3.7,1.6-5.8,2.5-6.2,2.7c1.2-2,7.9-12.7,17.5-28c6.6-10.5,14.5-23.3,22.9-36.7l0,0
								c24.2-21.2,45.9-54.3,72.8-46.4s52.5,5.4,60.7-6.2l0.3-0.4C350.6,405.1,352.7,407.5,354.3,410.4z"/>
							<path fill="#5CBBE5" d="M306.8,380.8l-3.2,6.5c0.3-1.8,0-6-8.5-5.7c-10.8,0.4-37.4,16.6-41.7,11.2c0.9-1.4,1.7-2.8,2.6-4.1
								C262.9,393,289,373.7,306.8,380.8z"/>
						</g>
						</svg>

				</div>

				<div className="bottom" ref="bottom">
					<button className="btnPill hover start" ref="startbutton" onClick={e => this.animateOut(true)}><span>Start Game</span></button>
					{ this.props.token !== undefined && // show if token available
						<button className="btnPill hover leaderboard" ref="playback" onClick={e => this.quickJump('/win')}><span>View Playback</span></button>
					}
					{/* <button className="btnPill hover leaderboard" ref="leaderboard" onClick={e => this.animateOut(false)}><span>Leaderboard</span></button> */}
				</div>

				<div className="legalese">© FullStory v0.41</div>
			</div>
		);
	}
}

const StartScreen = connect(() => mapStateToProps, mapDispatchToProps)(StartScreenView);
export default StartScreen;



// WEBPACK FOOTER //
// ./src/components/scenes/StartScreen.js